export const en_language_data = {
  Loading: "Loading",
  Login: "Login",
  LoginWithUsernameandPassword: "Login with your Username and Password",
  UserID: "User ID",
  Password: "Password",
  EnterUserName: "Enter User Name",
  EnterPassword: "Enter Password",
  EnterPasswordValid: "Password must be between 8 and 16 characters long.",
  EnterPasswordPolicy:
    "Password must be 8-16 characters long, containing at least one uppercase letter, one lowercase letter, one number, and one special character, with no spaces allowed.",
  ForgotPassword: "Forgot Password",
  UsernameisRequired: "User Name is a required",
  PasswordisRequired: "Password is a required",
  MobileNoisRequired: "Mobile No. is Required.",
  MobileNoisValid: "Please enter valid Mobile No.",
  UserNm: "User Name",
  UsernamenandPasswordisRequired: "UserName and Password is a required",
  ThisFieldisrequired: "This field is required.",
  Next: "Next",
  backtologin: "back to login",
  Save: "Save",
  Yes: "Yes",
  No: "No",
  Nodatafound: "No data found..!",
  Confirmation: "Confirmation",
  Filter: "Filter",
  Apply: "Apply",
  Clear: "Clear",
  FailedToAddFollowingFilesForUpload:
    "Failed To Add Following Files For Upload",
  FileUpload: "File Upload",
  FileViewer: "File Viewer",
  File: "File",
  Type: "Type",
  Size: "Size",
  DoyouwanttosavethisRequest: "Do you want to save this Request?",
  DoyouwanttosavethisRecord: "Do you want to save this Record?",
  DoyouwanttoacceptthisRequest: "Do you want to accept this Request?",
  DoYouwanttorejectthisRequest: "Do you want to reject this Request?",
  Doyouwanttorevertthisrequest: "Do you want to revert this request?",
  Youcannotacceptyourownentry: "You can not accept your own entry.",
  Youcannotrejectyourownentry: "You can not reject your own entry.",
  Youcannotconfirmyourownentry: "You can not confirm your own entry.",
  RecordUpdatedsuccessfully: "Record Updated successfully.",
  ImageUpdatedsuccessfully: "Image Updated successfully.",
  Somethingwenttowrong: "Something went to wrong..",
  Recordssuccessfullydeleted: "Records successfully deleted",
  Requesthasbeenalreadyaccepted: "Request has been already accepted.",
  Requesthasbeenalreadyrejected: "Request has been already rejected.",
  Areyousuretoupdateservices: "Are you sure to update services?",
  Passwordsuccessfullyreset: "Password successfully reset",
  success: "success",
  Deleting: "Deleting...",
  profile: {
    UserProfile: "User Profile",
    EnableTOTPAuth: "Enable T-OTP Auth",
    DisableTOTPAuth: "Disabled T-OTP Auth",
    ChangePassword: "Change Password",
    LoginDate: "Login Date",
    UserID: "User ID",
    Name: "Name",
    LoginID: "Login ID",
    LoginFlag: "Login Flag",
    LogoutDate: "Logout Date",
    ActivityRemarks: "Activity Remarks",
    IPAddress: "IP Address",
    ReleasedUser: "Released User",
    ReleasedDate: "Released Date",
    SrNo: "Sr. No.",
    UserLevel: "User Level",
    MobileNumber: "Mobile Number",
    EnterMobileNumber: "Enter Mobile Number",
    EmailID: "Email ID",
    UserGroup: "User Group",
    UserSubType: "User Sub Type",
    BranchName: "Branch Name",
    AllowedRelease: "Allowed Release",
    required: "This Fields is Required.",
    Searchin: "Search in",
    SearchinScreens: "Search in {0} screens",
    screens: "screens",
    records: "records",
    // For Change Password in Profile
    CurrentPassword: "Current Password",
    NewPassword: "New Password",
    ConfirmPassword: "Confirm Password",
    Close: "Close",
    PasswordValidation:
      "The new password cannot be the same as the old password",
    ChangePasswordValidation:
      "Password should be alphanumeric and have at least one special character, one lowercase character, one uppercase character without any space in between.",
    ConfirmPasswordValidation:
      "New Password and Confirm Password did not matched",
    SetNewPassword: "Set New Password",
    EnterConfirmPassword: "Enter Confirm Password",
    // For Password in Verify
    PasswordVerify: "Password Verify",
    Verify: "Verify",
    ConfirmPasswordRequired: "Confirm Password is Required.",

    // For T-OTP in Profile
    EnabledAuth: "Enabled Authenticator",
    TOTP_Note: "Note: Enabled Authenticator",
    TOTP_Note1:
      "Scan QR code: Use any authenticator app to scan the provided QR code.",
    TOTP_Note2:
      "Enable two-factor authentication: Utilize the Time-based One-Time Password (TOTP) method for enhanced security.",
    TOTP_Note3:
      "Authenticator app options: You can choose any authenticator app, but Google Authenticator is recommended.",
    TOTP_Note4:
      "Scan QR code instruction: Instruct the user to scan the QR code in their chosen authenticator app.",
    TOTP_Note5:
      "Verify OTP: After scanning, the user should verify the One-Time Password (OTP) generated by the app.",
    EnterOTP: "Please Enter OTP",
    VerifyOTP: "Verify OTP",
  },

  // For OTP Verify
  otp: {
    OTPAuthentication: "OTP Authentication",
    PleaseEnterOTP: "Please Enter OTP",
    Back: "Back",
    Verify: "Verify",
    ResendOTP: "Resend OTP",
    EnterOTPDigit: "Please enter a 6 digit OTP number",
    ResendOTPIn: "OTP Resend In",
    Scecond: "Sec.",
  },
  // For Appbar
  appBar: {
    Branch: "Branch",
    LastLogin: "Last Login",
    UserID: "User ID",
    Role: "Role",
    Profile: "Profile",
    Logout: "Logout",
  },

  dashBoard: {
    LatestTransactions: "Latest Transactions",
    TrafficByDevice: "Traffic By Device",
    Success: "Success",
    Fail: "Fail",
    Today: "Today",
    LastWeek: "Last Week",
    LastMonth: "Last Month",
  },
  Web: "Web",
  IOS: "IOS",
  Android: "Android",
  Huawei: "Huawei",

  // config: {
  // All Screen
  Custom: "Custom",
  AllScreens: "All Screens",
  ScreenName: "Screen Name",
  UserCode: "User Code",
  SystemCode: "System Code",
  Release: "Release",
  ServiceActiveDeactiveConfiguration: "Service Active/Deactive Configuration",
  SrNo: "Sr. No.",
  ServiceName: "Service Name",
  Status: "Status",
  AccessChannel: "Access Channel",
  CardUser: "Card User",
  NonCardUser: "Non Card User",
  ServiceStopAlertMessage: "Service Stop Alert Message",
  EnterServiceStopAlertMessage: "Enter Service Stop Alert Message",
  TotalNoofRecords: "Total No. of",
  MessageEnglish: "Message (English)",
  EnterMessageEnglish: "Enter Message (English)",
  MessageLocal: "Message (Local)",
  EnterMessageLocal: "Enter Message (Local)",
  ServiceDeactivationConfigurationDetails:
    "Service Deactivation Configuration Details",
  FromDate: "From Date*",
  ToDate: "To Date*",
  Active: "Active",
  Action: "Action",
  FromDateToDate: "From Date should be less than To Date.",
  ToDateFromDate: "To Date should be greater than From Date.",
  FromDateToDatePrevious: "From Date should greater Than previous To Date.",
  Cancel: "Cancel",
  Edit: "Edit",
  New: "New",
  confirm: "confirm",
  Close: "Close",
  // Closes: "CLOSE",
  Add: "Add",
  AddRow: "Add Row",
  EditDetail: "Edit Detail",
  ViewDetails: "View Details",
  view: "view",
  Delete: "Delete",
  Update: "Update",
  ViewFile: "View File",
  ClearAll: "Clear All",
  Ok: "Ok",
  PopulateBusinessDay: "Populate Business Day",
  DateWiseServiceDisable: "Date Wise Service Disable",
  Messages: "Messages",
  Selected: "Selected",
  // Rowsperpage: "Rows per page:",

  //Marquee Text Configuration
  MarqueeTextConfiguration: "Marquee Text Configuration",
  Channel: "Channel",
  MarqueeTextEnglish: "Marquee Text (English)",
  MarqueeTextLocal: "Marquee Text (Local)",
  EffectiveFrom: "Effective From",
  EffectiveTo: "Effective To",
  EnterEffectiveFrom: "Enter Effective From",
  EnterMarqueeTextEnglish: "Enter Marquee Text (English)",
  EnterMarqueeTextLocal: "Enter Marquee Text (Local)",
  Mustbeavaliddate: "Must be a valid date",
  EffectiveToshouldbegreaterthanorequaltoEffectiveFrom:
    "Effective To should be greater than or equal to Effective From.",
  Wouldyouliketodeletetheselectedrecord:
    "Would you like to delete the selected record?",
  CommonMessageTemplete: "Common Message Templete",
  SelectCommonMessageTemplete: "Select Common Message Templete",

  //Email Account Setup

  EmailAccountSetup: "E-Mail SMTP Server Configuration",
  SentByName: "Sent By Name",
  SMTPServerIP: "SMTP Server IP",
  Port: "Port",
  SSLEnabled: "SSL Enabled",
  SecurePasswordAuthentication: "Secure Password Authentication",
  SecurePasswordAuthenticationEnabled: "Secure Password Authentication Enabled",
  PassAuth: "Pass Auth",
  UserName: "User Name",
  SMTPServer: "SMTP Server",
  PortNo: "Port No",
  NoteEMailSMTP: "Note :- Please ensure your E-Mail Account Enable for SMTP.",
  EnterSentByName: "Enter Sent By Name",
  EnterSMTPServer: "Enter SMTP Server",
  EnterPortNo: "Enter Port No",
  // EnterUserName: "Enter User Name",

  // District Master
  DistrictMaster: "District Master",
  DistrictCode: "Region Code",
  DistrictName: "Region Name",
  DivisionCode: "Division Code",
  DivisionName: "Division Name",
  GeoCode: "Geo Code",
  DistCD: "Dist. CD.",
  EnterDistrictCode: "Enter Region Code",
  EnterDistrictName: "Enter Region Name",
  EnterDivisionCode: "Enter Division Code",
  EnterDivisionName: "Enter Division Name",
  EnterGeoCode: "Enter Geo Code",
  EnterDistCD: "Enter Dist.CD.",

  // Service Wise Configuration

  ServiceWiseConfiguration: "Service Wise Configuration",
  Description: "Description",
  EnterDescription: "Enter Description",
  DailyLimit: "Daily Limit",
  MinimumAmount: "Minimum Amount",
  MaximumAmount: "Maximum Amount",
  TransactionType: "Transaction Type",
  ConfirmStatus: "Confirm Status",
  ModifiedBy: "Modified By",
  ModifiedDate: "Modified Date",
  EnterDailyLimit: "Enter Daily Limit",
  WeeklyLimit: "Weekly Limit",
  EnterWeeklyLimit: "Enter Weekly Limit",
  MonthlyLimit: "Monthly Limit",
  EnterMonthlyLimit: "Enter Monthly Limit",
  EnterMinimumAmount: "Enter Minimum Amount",
  EnterMaximumAmount: "Enter Maximum Amount",
  CardMinimumAmount: "Card Minimum Amount",
  EnterCardMinimumAmount: "Enter Card Minimum Amount",
  Execution: "Execution",
  StartTime: "Start Time",
  EnterStartTime: "Enter Start Time",
  EndTime: "End Time",
  EnterEndTime: "Enter End Time",
  VATPercentage: "VAT Percentage",
  EnterVATPercentage: "Enter VAT Percentage",
  MerchantID: "Merchant ID",
  EnterMerchantID: "Enter Merchant ID",
  TerminalID: "Terminal ID",
  EnterTerminalID: "Enter Terminal ID",
  WorkingDayStartFrom: "Working Day Start From",
  CoolDownPeriodInMinute: "Cool Down Period (In Minute)",
  EnterCoolDownPeriodInMinute: "Enter Cool Down Period (In Minute)",
  MaxDailyCount: "Max Daily Count",
  EnterMaxDailyCount: "Enter Max Daily Count",
  MaxMonthlyCount: "Max Monthly Count",
  EnterMaxMonthlyCount: "Enter Max Monthly Count",
  AmountLabel: "Amount Label",
  Accept: "Accept",
  Revert: "Revert",
  Reject: "Reject",

  Charge: "Charge",
  ServiceChargeTemplate: "Service Charge Template",
  SelectServiceChargeTemplate: "Select Service Charge Template",
  ServiceChargeAccount: "Service Charge Account",
  EnterServiceChargeAccount: "Enter Service Charge Account",
  VATAccount: "VAT Account",
  EnterVATAccount: "Enter VAT Account",
  TransactionParticulars: "Transaction Particulars",
  FinacleSuspenseCreditAccount: "Finacle Suspense Credit Account",
  EnterFinacleSuspenseCreditAccount: "Enter Finacle Suspense Credit Account",
  FinacleSuspenseDebitAccount: "Finacle Suspense Debit Account",
  EnterFinacleSuspenseDebitAccount: "Enter Finacle Suspense Debit Account",
  AbabilSuspenseCreditAccount: "Ababil Suspense Credit Account",
  EnterAbabilSuspenseCreditAccount: "Enter Ababil Suspense Credit Account",
  AbabilSuspenseDebitAccount: "Ababil Suspense Debit Account",
  EnterAbabilSuspenseDebitAccount: "Enter Ababil Suspense Debit Account",
  CardSuspenseCreditAccount: "Card Suspense Credit Account",
  EnterCardSuspenseCreditAccount: "Enter Card Suspense Credit Account",
  CardSuspenseDebitAccount: "Card Suspense Debit Account",
  EnterCardSuspenseDebitAccount: "Enter Card Suspense Debit Account",

  FinacleTransactionParticulars: "Finacle Transaction Particulars",
  FinacleTransactionParticulars2: "Finacle Transaction Particulars2",
  AbabilTransactionParticulars: "Ababil Transaction Particulars",
  AbabilTransactionParticulars2: "Ababil Transaction Particulars2",
  TranzwareTransactionParticulars: "Tranzware Transaction Particulars",
  TranzwareTransactionParticulars2: "Tranzware Transaction Particulars2",
  DynamicKeyword: "Dynamic Keyword",
  TransactionParticularsfor: "Transaction Particulars for",
  Finacle: "Finacle",
  Ababil: "Ababil",
  Tranzware: "Tranzware",
  AmountLabelMapping: "Amount Label Mapping",
  AmountLabelReq: "Amount Label*",
  AmountLabelisAlreadyenteredatLine: "Amount Label is Already entered at Line",
  Line: " ",

  ServiceWiseConfigurationConfirmation:
    "Service Wise Configuration Confirmation",
  ServiceWiseConfirmation: "Service Wise Confirmation",

  FinacleAsFromSource: "Finacle As From Source",
  AbabilAsFromSource: "Ababil As From Source",
  TranzwareAsFromSource: "Tranzware As From Source",

  //  Leaves Master

  LeavesMaster: "Leaves Master",
  Template: "Template",
  DeactiveDate: "Deactive Date",
  EnteredBy: "Entered By",
  EnteredDate: "Entered Date",
  MachineName: "Machine Name",
  LastModifiedBy: "Last Modified By",
  LastMachinename: "Last Machine name",
  EnteraTemplate: "Enter a Template",
  NumberofLeaves: "Number of Leaves*",
  EnterNumberofLeaves: "Enter Number of Leaves",
  NumberofLeavesisAlreadyenteredatLine:
    "Number of Leaves is Already entered at Line {0}",

  //Service Charge Template

  EffectiveDate: "Effective Date",
  LastEnteredBy: "Last Entered By",
  LastEnteredDate: "Last Entered Date",
  LastModifiedDate: "Last Modified Date",
  ServiceChargeTemplateConfirmation: "Service Charge Template Confirmation",
  ServiceChargeTemplateConfiguration: "Service Charge Template Configuration",
  FromAmount: "From Amount*",
  ToAmount: "To Amount*",
  ChargeAmountReq: "Charge Amount*",
  ChargePercent: "Charge %",
  Compute: "Compute*",
  Computes: "Compute",
  FromAmountshouldbelessthenToAmount:
    "From Amount should be less then To Amount",
  FromAmountShouldBeGreaterThanPreviousToAmountOnSameDate:
    "From Amount Should Be Greater Than Previous To Amount On Same Date & Currency",
  ToAmountshouldbegreaterthanFromAmount:
    "To Amount should be greater than From Amount",

  //Holiday/Business Day Configuration
  HolidayBusinessDayConfiguration: "Holiday/Business Day Configuration",
  StartDate: "Start Date",
  EndDate: "End Date",
  HolidayConfiguration: "Holiday Configuration",
  EndDateshouldbegreaterthanStartDate:
    "'End Date' should be greater than 'Start Date'.",
  InvaliddaterangeEndDateshouldbegreaterthanStartDate:
    "Invalid date range. 'End Date' should be greater than 'Start Date'.",
  Holidays: "Holidays",

  BusinessDayConfig: "Business Day Config",
  Note: "Note :",
  Note1:
    "Business Days have already been generated. You can check in Business Day Configuration Screen.",
  Note2: "Click on 'Populate Business Day' button to Generate Business Days.",
  BranchNameReq: "Branch Name*",
  HolidayConfig: "Holiday Config",
  BusinessDayConfiguration: "Business Day Configuration",
  Date: "Date",
  DayName: "Day Name",
  BusinessDayHoliday: "Business Day/Holiday",
  ThisValuealreadyexists: "This Value already exists.",
  Entervaliddate: "Enter valid date",
  Dateshould: "",
  Dateshouldbebetween: "Date should be between {0}",
  HolidayDate: "Holiday Date*",
  HolidayDescription: "Holiday Description*",
  HolidayType: "Holiday Type*",
  BranchNameisAlreadyenteredatLine:
    "Branch Name is Already entered at Line {0}",

  //Scheme Master
  SchemeMaster: "Scheme Master",
  SchemeCode: "Scheme Code",
  ParentType: "Parent Type",
  EnterParentType: "Enter Parent Type",
  SchemeMasterConfirmation: "Scheme Master Confirmation",
  LeavesTemplate: "Leaves Template",
  Charges: "Charges",
  Service: "Service",
  EnterSchemeCode: "Enter Scheme Code",
  Populate: "Populate",

  //Operator Master

  OperatorMasterconfirmation: "Operator Master confirmation",
  OperatorMaster: "Operator Master",
  OperatorType: "Operator Type",
  OperatorID: "Operator ID",
  EnterOperatorID: "Enter Operator ID",
  OperatorName: "Operator Name",
  EnterOperatorName: "Enter Operator Name",
  UPLOADVIEWImage: "UPLOAD/VIEW Image",

  TrnParticulars: "Trn. Particulars",
  EnterTrnParticulars: "Enter Trn. Particulars",
  TrnParticulars2: "Trn. Particulars2",
  EnterTrnParticulars2: "Enter Trn. Particulars2",
  ChargeTemplate: "Charge Template",
  SpecialAmount: "Special Amount",
  AmountLabelAlreadyenteredatLine: "Amount Label Already entered at Line {0}",
  AccountNumber: "Account Number",
  EnterAccountNumber: "Enter Account Number",
  MaximumAmountshouldbeGreaterthanorequaltoMinimumAmount:
    "Maximum Amount should be Greater than or equal to Minimum Amount.",
  MinimumAmountshouldbeLessthanorequalToMaximumAmount:
    "Minimum Amount should be Less than or equal To Maximum Amount.",
  Doubleclicktochangetheimage: "Double click to change the image",
  OptionisAlreadyenteredatLine: "Option is Already entered at Line {0}",
  OptionType: "Option Type*",
  OperatorIcon: "Operator Icon",
  Uptosixrowsareallowedtobeadded: "Up to six rows are allowed to be added.",
  VIEWImage: "VIEW Image",

  // Source Parent Type Master

  SourceParentTypeMaster: "Source Parent Type Master",
  SourceName: "Source Name",
  SourceType: "Source Type",
  EnterSourceType: "Enter Source Type",
  DisplayOrder: "Display Order",
  EnterDisplayOrder: "Enter Display Order",
  SignUpAllow: "SignUp Allow",
  BeneficiaryAllow: "Beneficiary Allow",

  //Insurance Master
  InsuranceMaster: "Insurance Master",
  Code: "Code",
  EnterCode: "Enter Code",
  AccountSource: "Account Source",
  EnterTransactionParticulars: "Enter Transaction Particulars",
  TransactionParticulars2: "Transaction Particulars2",
  EnterTransactionParticulars2: "Enter Transaction Particulars2",
  Remark: "Remark",
  EnterRemark: "Enter Remark",
  PolicyLabelEnglish: "Policy Label(English)",
  EnterPolicyLabelEnglish: "Enter Policy Label(English)",
  PolicyLabelLocal: "Policy Label(Local)",
  EnterPolicyLabelLocal: "Enter Policy Label(Local)",

  // University Master
  UniversityMaster: "University Master",
  PaymentID: "Payment ID*",
  EnterPaymentID: "Enter Payment ID",
  PaymentHeader: "Payment Header*",
  EnterPaymentHeader: "Enter Payment Header",

  // Utility Master
  UtilityMaster: "Utility Master",

  // Club Master
  ClubMaster: "Club Master",
  MemberDetails: "Member Details",
  DownloadSample: "Download Sample",
  Upload: "Upload",
  UploadFile: "Upload File",
  ClubMemberDetail: "Club Member Detail",
  ClubMemberDetails: "Club Member Details",
  MemberID: "Member ID",
  EnterMemberID: "Enter Member ID",
  MemberName: "Member Name",
  EnterMemberName: "Enter Member Name",
  MemberType: "Member Type",
  EnterMemberType: "Enter Member Type",
  MemberSince: "Member Since",
  MemberStatus: "Member Status",
  EnterMemberStatus: "Enter Member Status",
  EntryDate: "Entry Date",
  ClubMember: "Club Member",
  Futuredatesarenotallowed: "Future dates are not allowed.",

  InvalidDateareNotAllowedinMemberSinceColumn:
    "Invalid Date are Not Allowed in Member Since Column",
  FutureDateareNotAllowedinMemberSinceColumn:
    "Future Date are Not Allowed in Member Since Column",
  Requiredfieldscannotbenull: "Required fields cannot be null",
  DoyouwanttoUpdateClubMemberData: "Do you want to Update Club Member Data?",
  Whichformatdoyouwanttodownload: "Which format do you want to download?",
  Excel: "Excel",
  CSV: "CSV",

  //Branch Master

  BranchMaster: "Branch Master",
  BranchCode: "Branch Code",
  Address: "Address",
  ContactNumber: "Contact Number",
  EmailID: "Email ID",
  EnterEmailID: "Enter Email ID",
  FileDownload: "File Download",

  ContactPerson: "Contact Person",
  EnterContactPerson: "Enter Contact Person",
  ContactPersonBranchManagerDetails: "Contact Person/Branch Manager Details",
  PayOrderAllow: "Pay Order Allow",
  ChequeBookAllow: "Cheque Book Allow",
  DPSAllow: "DPS Allow",
  FDAllow: "FD Allow",
  District: "District",
  EnterAddress: "Enter Address",
  Longitude: "Longitude",
  EnterLongitude: "Enter Longitude",
  Latitude: "Latitude",
  EnterLatitude: "Enter Latitude",
  Phone1: "Phone(1)",
  EnterPhone1: "Enter Phone(1)",
  Phone2: "Phone(2)",
  EnterPhone2: "Enter Phone(2)",
  EMailisinvalid: "E-Mail is invalid.",
  OpenDate: "Open Date",
  BranchName: "Branch Name",
  EnterBranchName: "Enter Branch Name",
  EnterBranchCode: "Enter Branch Code",
  Norowsfoundforupdate: "No rows found for update",
  DoyouwanttoUpdateBranchMasterData:
    "Do you want to Update Branch Master Data?",
  MobileNumber: "Mobile Number",
  EnterMobileNumber: "Enter Mobile Number",

  //OTP SMS Configuration
  OTPSMSConfiguration: "Mobile OTP SMS Configuration",
  ActionCode: "Action Code",
  EnterActionCode: "Enter Action Code",
  ActionDescription: "Action Description",
  EnterActionDescription: "Enter Action Description",
  SMSText: "SMS Text",
  EnterSMSText: "Enter SMS Text",

  //Tenure Type Configuration
  TenureTypeConfiguration: "Tenure Type Configuration",
  AccountType: "Account Type",
  TransactionTypeDisplay: "Transaction Type Display",
  AccountTypesDisplay: "Account Type Display",
  TenureTypeReq: "Tenure Type*",
  TenureReq: "Tenure*",
  Tenures: "Tenures",
  EnterTenure: "Enter Tenure",
  EffectiveFromReq: "Effective From*",

  //Email/SMS Template Configuration

  EmailSMSTemplateConfiguration: "Email/SMS Template Configuration",
  TranType: "Tran. Type",
  EnterTranType: "Enter Tran. Type",
  MailSubject: "Mail Subject",
  EnterMailSubject: "Enter Mail Subject",
  SenderMailID: "Sender Mail ID",
  EnterSenderMailID: "Enter Sender Mail ID",
  CCMailID: "CC Mail ID",
  EnterCCMailID: "Enter CC Mail ID",
  DisplaySenderName: "Display Sender Name",
  EnterDisplaySenderName: "Enter Display Sender Name",
  MailServer: "Mail Server",
  SMS: "SMS",
  Email: "Email",
  SorrythecontentyouaretryingtouploadmustbeinHTMLformat:
    "Sorry, the content you are trying to upload must be in HTML format.",
  EmailConfiguration: "Email Configuration",
  Import: "Import",
  EmailText: "Email Text",
  EnterEmailText: "Enter Email Text",
  Keys: "Keys",
  NoteImportHTMLFile:
    "Note: To import an HTML file, either drag and drop it into the Email Text box or click the 'Import' button above.",
  InvalidMailSenderMailID: "Invalid Mail Sender Mail ID.",
  SMSConfiguration: "SMS Configuration",

  //Beneficiary Restriction Master
  BeneficiaryRestrictionMaster: "Beneficiary Restriction Configuration",
  RestrictionType: "Restriction Type",
  Value: "Value",
  BeneficiaryLabel: "Beneficiary Label",
  AccountName: "Account Name",
  EnterAccountName: "Enter Account Name",
  ProductCode: "Product Code",
  EnterProductCode: "Enter Product Code",
  RoutingNumber: "Routing Number",
  EnterRoutingNumber: "Enter Routing Number",
  RecordAlreadyExists: "Record Already Exists.",

  // ATM Locator Master
  ATMLocatorMaster: "ATM Locator Master",
  ATMLocation: "ATM Location",
  EnterATMLocation: "Enter ATM Location",
  Address1: "Address 1",
  EnterAddress1: "Enter Address 1",
  Address2: "Address 2",
  EnterAddress2: "Enter Address 2",
  Address3: "Address 3",
  EnterAddress3: "Enter Address 3",
  PostalCode: "Postal Code",
  EnterPostalCode: "Enter Postal Code",
  ActiveStatus: "Active Status",
  DoyouwanttoupdateATMLocatormasterdata:
    "Do you want to update ATM Locator master data?",

  //Screen Note Configuration
  ScreenNoteConfiguration: "Screen Note Configuration",
  ScreenID: "Screen ID",
  EnglishNote: "English Note",
  BanglaNote: "Bangla Note",
  English: "English*",
  EnterEnglishMessage: "Enter English Message",
  Bangla: "Bangla",
  EnterBanglaMessage: "Enter Bangla Message",
  Translate: "Translate",

  //Guessable Password Entry
  GuessablePasswordEntry: "Guessable Password Entry",
  GuessablePassword: "Guessable Password",
  EnterGuessablePassword: "Enter Guessable Password",

  //Banner Configuration

  BannerConfiguration: "Banner Configuration",
  BannerType: "Banner Type",
  BannerDescription: "Banner Description",
  LoginID: "Login ID",
  EnterLoginID: "Enter Login ID",
  ChannelReq: "Channel*",
  Invaliddate: "Invalid date",
  ViewUploadHTML: "View/Upload HTML",
  Htmltext: "Html text",
  EnterHtmltext: "Enter Html text",
  BannerNote:
    "Note: To import an HTML file, either drag and drop it into the Email Text box or click the 'Import' button above.",
  DropHere: "Drop Here",
  DropHTMLFileHere: "Drop HTML File Here",
  DisplayType: "Display Type",
  InvalidLoginID: "Invalid Login ID.",

  //Guideline File Configuration
  GuidelineFileConfiguration: "Guideline File Configuration",
  UseCase: "Use Case",
  UploadDate: "Upload Date",
  FileName: "File Name",
  EnterFileName: "Enter File Name",
  FileType: "File Type",
  Filesizeshouldbelessthan5MB: "File size should be less than 5 MB.",
  PleaseSelectPDFFileonly: "Please Select PDF File only.",
  Nofilefoundtopreview: "No file found to preview!",

  // FD Scheme Configuration
  FDSchemeConfiguration: "FD Scheme Configuration",
  FDAccounttype: "FD Account type",
  TenureTypeFinacle: "Tenure Type Finacle",
  Tenure: "Tenure",
  Renewal: "Renewal",
  EnterRenewal: "Enter Renewal",
  MaturityInst: "Maturity Inst.",
  EnterMaturityInst: "Enter Maturity Inst",
  NatureofAccount: "Nature of Account",
  EnterNatureofAccount: "Enter Nature of Account",
  TenureTypeRate: "Tenure Type Rate",
  EnterTenureTypeRate: "Enter Tenure Type Rate",
  CCY: "CCY.",
  EnterCCY: "Enter CCY",
  SchemeDescription: "Scheme Description",
  EnterSchemeDescription: "Enter Scheme Description",
  TDModAmount: "TD Mod Amount",
  EnterTDModAmount: "Enter TD Mod Amount",
  SampleFileDownload: "Sample File Download",
  FdAccountType: "Fd Account Type",
  EnterFdAccountType: "Enter Fd Account Type",
  DoyouwanttoUpdateFDSchemeMasterData:
    "Do you want to Update FD Scheme Master Data?",
  FDSchemeMaster: "FD Scheme Master",

  //Parameter Master
  Parameter: "Parameter",
  ParameterMaster: "Parameter Master",
  DataType: "Data Type",
  GlobalLevel: "Global Level",
  HOLevel: "HO Level",
  EnterValue: "Enter Value",
  ParameterConfirmation: "Parameter Confirmation",
  NewParameterValue: "New Parameter Value",
  OldParameterValue: "Old Parameter Value",
  NewDatatype: "New Datatype",
  OldDatatype: "Old Datatype",

  //Miscellaneous Master
  MiscellaneousMaster: "Miscellaneous Master",
  CategoryCode: "Category Code",
  EnterCategoryCode: "Enter Category Code",
  DataValue: "Data Value",
  EnterDataValue: "Enter Data Value",
  DisplayValue: "Display Value",
  EnterDisplayValue: "Enter Display Value",

  //User Block Configuration
  UserBlockConfiguration: "User Block Configuration",
  ConfigType: "Config Type",
  FailAttempt: "Fail Attempt",
  MinutesOfBlock: "Minutes Of Block",
  EnterMinutesOfBlock: "Enter Minutes Of Block",
  AutoRelease: "Auto Release",
  EnterNoOfFailAttempt: "Enter No. Of Fail Attempt",
  OldFailAttempt: "Old Fail Attempt",
  OldMinutesOfBlock: "Old Minutes Of Block",
  UserBlockConfigurationConfirmation: "User Block Configuration Confirmation",

  //Application Review User Master
  ApplicationReviewUserMaster: "Application Review User Master",
  LoginName: "Login Name",
  TestLoginID: "Test Login ID",
  ReviewLoginName: "Review Login Name",
  LatestVersion: "Latest Version",
  EnterLatestAppVersion: "Enter Latest App Version",
  ExpiryDate: "Expiry Date",
  TestUserLastLoginDate: "Test User Last Login Date",
  EnterTestLoginID: "Enter Test Login ID",
  EnterReviewLoginName: "Enter Review Login Name",
  EnterLatestVersion: "Enter Latest Version",
  Spaceatthebeginningisnotallowed: "Space at the beginning is not allowed.",
  EnteraproperMobileAppVersion: "Enter a proper Mobile App Version.",
  Pastdateisnotallowed: "Past date is not allowed.",
  EnterTestUserLastLoginDate: "Enter Test User Last Login Date",

  //Validation Message Master
  ValidationMessageMaster: "Validation Message Master",
  MessageCode: "Message Code",
  EnglishMessage: "English Message",
  BanglaMessage: "Bangla Message",
  EnglishLan: "English",

  //Card BIN Image Configuration
  CardBINImageConfiguration: "Card BIN Image Configuration",
  CardBin: "Card Bin",
  AllowBanglaQR: "Allow Bangla QR",
  CardImage: "Card Image",
  UserStatus: "User Status",
  CardBinImageUpload: "Card Bin Image Upload",
  CardBinNumber: "Card Bin Number",
  EnterCardBinNumber: "Enter Card Bin Number",
  Imagesizeshouldbelessthan5MB: "Image size should be less than 5 MB.",
  PleaseSelectValidFormat: "Please Select Valid Format.",
  ClicktouploadtheCardImage: "Click to upload the Card Image",
  UploadCardImage: "Upload Card Image",
  ClickontheCardImageboxtouploadImage:
    "Click on the Card Image box to upload Image.",
  MaximumImageSizeshouldbe5MB: "Maximum Image Size should be 5 MB.",
  ImageformatshouldbeJPEGorPNG: "Image format should be JPEG or PNG.",

  // MS Monitoring Master

  MSMonitoringMaster: "MS Monitoring Master",
  ServiceID: "Service ID",
  ActiveInstance: "Active Instance",
  MSInstanceInformations: "MS Instance Informations",
  InstanceID: "Instance ID",
  PropertiesList: "Properties List",
  Properties: "Properties",
  MicroServiceList: "Micro Service List",
  InstanceStatus: "Instance Status",
  UpdateStatus: "Update Status",
  APIResponse: "API Response",

  //Service wise Mobile Number Validation Template Mapping
  ServiceWiseMobileNumberValidationMaster:
    "Service Wise Mobile Number Validation Master",
  TemplateName: "Template Name",
  ServiceWiseMobileNumberValidationConfirmation:
    "Service Wise Mobile Number Validation Confirmation",

  //IDTP Charge Configuration

  IDTPChargeConfiguration: "IDTP Charge Configuration",
  ReceiverFI: "Receiver FI*",
  IDTPChargeConfigurationConfirmation: "IDTP Charge Configuration Confirmation",
  NewServiceChargeTemplate: "New Service Charge Template",
  OldServiceChargeTemplate: "Old Service Charge Template",
  NewVATPercentage: "New VAT Percentage",
  OldVATPercentage: "Old VAT Percentage",

  //Service Monitoring Master
  ServiceMonitoringMaster: "Service Monitoring Master",
  LastExecutionDate: "Last Execution Date",

  //MS Service Message Configuration
  MSServiceMessageConfiguration: "MS Message Configuration",
  KeyName: "Key Name",
  EnterKeyName: "Enter Key Name",
  DefaultMessage: "Default Message",
  EnterDefaultMessage: "Enter Default Message",
  LocalLanguageMessage: "Local Language Message",
  EnterLocalLanguageMessage: "Enter Local Language Message",
  Orderby: "Order by",
  Comments: "Comments",

  //MS Properties Configuration
  MSPropertiesConfiguration: "MS Properties Configuration",
  ApplicationName: "Application Name",
  ProfileName: "Profile Name",
  Label: "Label",
  AreyousuretodeleteselectedMobileNumberValidationTemplate:
    "Are you sure to delete selected Mobile Number Validation Template?",
  Key: "Key",
  EnterKey: "Enter Key",
  NoteOne: "1. *-Replace the key value with * upto length. EX.ACCOUNT=*{' '}",
  NoteTwo:
    "2. If blank then replace key value with empty string. EX.accountNumber={' '}",
  NoteThree:
    "3. If format is specify then system will match the format and masked value as per given format but format length must be same as key value length. If format not match with value length then no masking will perform. EX.$[1234******123,1234******123578]{' '}",
  NoteFour:
    "4. If key name specify here is contain values as JSON object/JSON array then the value will be replaced with ''''.'{' '}",

  // Virtual Card Image Configuration
  CardImageConfiguration: "Card Image Configuration",
  CardImageConfirmation: "Card Image Configuration Confirmation",
  ImageID: "Image ID",
  EnterImageID: "Enter Image ID",
  CardImageUpload: "Card Image Upload",

  //Web Rerouting Configuration
  WebReroutingConfiguration: "Web Rerouting Configuration",
  ActionMenu: "Action Menu",
  PopupStatus: "Popup Status",
  LoginStatus: "Login Status",
  LabelEnglish: "Label (English)",
  EnterEnglishLanguageLabel: "Enter English Language Label",
  LabelLocalLanguage: "Label (Local Language)",
  EnterLocalLanguageLabel: "Enter Local Language Label",
  PleaseentervalidURL: "Please enter valid URL.",
  PopupMessageEnglish: "Popup Message (English)",
  EnterEnglishLanguagePopupMessage: "Enter English Language Popup Message",
  PopupMessageLocalLanguage: "Popup Message (Local Language)",
  EnterLocalLanguagePopupMessage: "Enter Local Language Popup Message",
  ServiceCode: "Service Code",
  EnterServiceCode: "Enter Service Code",
  APIPassword: "API Password",
  EnterAPIPassword: "Enter API Password",
  APIUserID: "API User ID",
  EnterAPIUserID: "Enter API User ID",
  URL: "URL",
  EnterURL: "Enter URL",
  WebReroutingConfirmation: "Web Rerouting Confirmation",
  MenuIcon: "Menu Icon",
  ClicktouploadtheMenuIcon: "Click to upload the Menu Icon",
  UploadMenuIcon: "Upload Menu Icon",
  ClickontheMenuIconboxtouploadIcon:
    "Click on the Menu Icon box to upload Icon.",
  MaximumIconSizeshouldbe5MB: "Maximum Icon Size should be 5 MB.",
  IconformatshouldbeJPEGorPNG: "Icon format should be JPEG or PNG.",

  //Payment Gateway Merchant Master
  PaymentGatewayMerchantMaster: "Payment Gateway Merchant Master",
  PaymentGatewayMerchantNameReq: "Payment Gateway Merchant Name*",
  EnterPaymentGatewayMerchantName: "Enter Payment Gateway Merchant Name",

  //Merchant Onboarding Confirmation
  MerchantOnboardingConfirmation: "Merchant Onboarding Confirmation",
  MerchantOnboardingConfiguration: "Merchant Onboarding Configuration",
  GateWayPasswordValidation:
    "Gateway Password should be alphanumeric and have at least one special character, one lowercase character, one uppercase character without any space in between.",
  PerTransactionLimit: "Per Transaction Limit",
  EnterPerTransactionLimit: "Enter Per Transaction Limit",
  GatewayEmail: "Gateway Email",
  EnterGatewayEmail: "Enter Gateway Email",
  InvalidMailGatewayEmail: "Invalid Mail Gateway Email.",
  PercentageofVAT: "Percentage of VAT",
  EnterPercentageofVAT: "Enter Percentage of VAT",
  ToAccountNumber: "To Account Number",
  EnterToAccountNumber: "Enter To Account Number",
  GatewayUsername: "Gateway Username",

  GatewayPassword: "Gateway Password",
  EnterGatewayPassword: "Enter Gateway Password",
  PleaseEnterURL: "Please Enter URL.",

  //PGW Merchant Users
  PGWMerchantUsers: "PGW Merchant Users",
  UserRole: "User Role",
  PGWMerchantUsersConfirmation: "PGW Merchant Users Confirmation",
  PGWMerchantUserCreation: "PGW Merchant User Creation",
  GatewayNamePID: "Gateway Name (PID)",
  PleaseentervalidIPAddress: "Please enter valid IP Address.",
  IPAddress: "IP Address",
  EnterIPAddress: "Enter IP Address.",
  EmailIDisinvalid: "Email ID is invalid",
  GatewayName: "Gateway Name",
  ConfirmationStatus: "Confirmation Status",

  //Mobile Number Validation Template
  MobileNumberValidationTemplate: "Mobile Number Validation Template",
  MobileNoLengthReq: "Mobile No. Length*",
  EnterMobileNoLength: "Enter Mobile No. Length",
  MobileNoStartFrom: "Mobile No. Start From",
  EnterMobileNoStartFrom: "Enter Mobile No. Start From",
  DescriptionReq: "Description*",

  //Dynamic Biller Deletion Request Confirmation
  DynamicBillerDeletionRequestConfirmation:
    "Dynamic Biller Deletion Request Confirmation",
  DynamicBillerConfirmation: "Dynamic Biller Confirmation",
  DynamicBillerConfiguration: "Dynamic Biller Configuration",
  CategoryID: "Category ID",
  EnterCategoryID: "Enter Category ID",
  SubCategoryID: "Sub Category ID",
  EnterSubCategoryID: "Enter Sub Category ID",
  BillerID: "Biller ID",
  EnterBillerID: "Enter Biller ID",
  BilleName: "Biller Name",
  EnterBilleName: "Enter Biller Name",
  SubCategoryName: "Sub Category Name",
  CategoryName: "Category Name",
  BillerDescription: "Biller Description",
  SubCategoryDescription: "Sub Category Description",
  CategoryDescription: "Category Description",
  BillerInfoURL: "Biller Info URL",
  BillerPaymentURL: "Biller Payment URL",
  Refresh: "Refresh",
  ScreenNotes: "Screen Notes",
  FieldOptions: "Field Options",
  Options: "Options",
  BillerDetails: "Biller Details",
  Doyouwanttoupdateselectedbillerdata:
    "Do you want to update selected biller data?",
  RefreshDynamicBillerConfiguration: "Refresh Dynamic Biller Configuration",
  DynamicBillerScreenNotes: "Dynamic Biller Screen Notes",
  Language: "Language",
  ScreenMessage: "Screen Message",
  EnterScreenMessage: "Enter Screen Message",
  FieldName: "Field Name",
  FieldType: "Field Type",
  Required: "Required",
  Datatype: "Datatype",
  MinimumValue: "Minimum Value",
  MaximumValue: "Maximum Value",
  LabelEnglish1: "Label English",
  LabelBangla: "Label Bangla",
  DefaultValue: "Default Value",
  TextAlign: "Text Align",
  Placeholder: "Placeholder",
  ValidationRegex: "Validation Regex",
  IsBeneficiaryField: "Is Beneficiary Field",
  RequireForBillInfo: "Require For Bill Info",
  DisplaySequence: "Display Sequence",
  IspayableAmount: "Is payable Amount",
  IsBillNumber: "Is Bill Number",
  IsFromAccountField: "Is From Account Field",
  IsReadonlyField: "Is Readonly Field",
  OptionsName: "Options Name",
  OptionsValue: "Options Value",
  ParameterKeys: "Parameter Keys",
  DynamicBillerURLs: "Dynamic Biller URLs",
  BillerFields: "Biller Fields",
  BillInfoParameters: "Bill Info Parameters",
  BillPaymentParameters: "Bill Payment Parameters",
  BillerName: "Biller Name",
  DynamicBillerAccountsChargeConfirmation:
    "Dynamic Biller Accounts/Charge Confirmation",
  FinaclePoolAccount: "Finacle Pool Account",
  EnterFinaclePoolAccount: "Enter Finacle Pool Account",
  AbabilPoolAccount: "Ababil Pool Account",
  EnterAbabilPoolAccount: "Enter Ababil Pool Account",
  DynamicBillerChargeConfiguration: "Dynamic Biller Charge Configuration",
  SubCategoryImage: "Sub Category Image",
  BillerImage: "Biller Image",
  NoteDoubleclickontheImageboxtouploadanewImage:
    "Note: Double-click on the Image box to upload a new Image.",

  //Bank Master
  BankMaster: "Bank Master",
  BankCode: "Bank Code",
  EnterBankCode: "Enter Bank Code",
  NPSBBankCode: "NPSB Bank Code",
  EnterNPSBBankCode: "Enter NPSB Bank Code",
  BankName: "Bank Name",
  EnterBankName: "Enter Bank Name",
  NPSB: "NPSB",
  BEFTN: "BEFTN",
  RTGS: "RTGS",
  ROWTYPE: "ROW TYPE",
  NPSBENABLED: "NPSB ENABLED",
  BEFTNENABLED: "BEFTN ENABLED",
  RTGSENABLED: "RTGS ENABLED",
  Pleaseselectrecords: "Please select records.",
  Doyouwanttodeletetheselectedrecords:
    "Do you want to delete the selected records?",
  Pleaseselectoneusertogetthedetails:
    "Please select one user to get the details",
  UpdateServiceStatus: "Update Service Status",
  BankServiceStatusTitle: "Bank Service Status Updation",
  BankServiceStatusCountNote: "Selected Banks: ",
  BankServiceStatusNote:
    "Note: Please choose the service and status for updating across all the selected banks.",
  BankServiceStatusUpdateMsg:
    "Are you sure you want to {0} the {1} service in all the selected banks?",
  DoyouwanttoUpdateBankMasterData: "Do you want to Update Bank Master Data?",
  OperationFailed: "Operation Failed.",

  // MFS Configuration

  MFSConfiguration: "MFS Configuration",
  MFSService: "MFS Service",
  MFSID: "MFS ID",
  EnterMFSID: "Enter MFS ID",
  MFSName: "MFS Name",
  EnterMFSName: "Enter MFS Name",
  MaximunDailyLimit: "Maximun Daily Limit",
  MFSLabelEnglish: "MFS Label (English)",
  EnterMFSEnglishLanguageLabel: "Enter MFS English Language Label",
  MFSLabelLocal: "MFS Label (Local)",
  EnterMFSLocalLanguageLabel: "Enter MFS Local Language Label",
  TranCode: "Tran Code",
  Perdaymaxaddmoneyinbeneficiary: "Per day max add money in beneficiary",
  EnterPerdaymaxaddmoneyinbeneficiary:
    "Enter Per day max add money in beneficiary",
  MFSConfigurationConfirmation: "MFS Configuration Confirmation",
  MFSIcon: "MFS Icon",

  //From Source Key Value Configuration
  FromSourceKeyValueConfiguration: "From Source Key Value Configuration",
  Services: "Service",
  DescriptionisAlreadyenteredatLine:
    "Description is Already entered at Line {0}",
  AllowDisallowReq: "Allow/Disallow*",
  ResponseKeyValue: "Response Key Value",
  ResponseKey: "Response Key",
  ResponseKeyValueReq: "Response Key Value*",
  EnterResponseKeyValue: "Enter Response Key Value",

  //Card Activate/Deactivate Status Configuration
  CardActivateDeactivateStatusConfiguration:
    "Card Activate/Deactivate Status Configuration",
  CardStatus: "Card Status",
  OperationType: "Operation Type",
  StatusValue: "Status Value",
  EnterStatusValue: "Enter Status Value",
  EnableStatusReq: "Enable Status*",
  EnablestatusisAlreadyenteredatLine:
    "Enable status is Already entered at Line {0}",
  StatusValueReq: "Status Value*",
  StatusValueisAlreadyenteredatLine:
    "Status Value is Already entered at Line {0}",

  // Product Display Name Configuration
  ProductDisplayNameConfiguration: "Product Display Name Configuration",
  DisplayName: "Display Name",
  Enterdisplayname: "Enter display name",
  CompanyCode: "Company Code",
  SchemeCodeCardBINReq: "Scheme Code/Card BIN*",
  EnterschemecodeCarBINno: "Enter scheme code/Card BIN no.",
  SchemeCodeCardBINNoisAlreadyenteredatLine:
    "Scheme Code/Card BIN No is Already entered at Line {0}",
  SchemeNameReq: "Scheme Name*",
  Enterschemename: "Enter scheme name",

  //Application Version Master
  ApplicationVersionMaster: "Application Version Master",
  DeviceOS: "Device O.S.",
  Version: "Version",
  PopupMessage: "Popup Message",
  ForceUpdate: "Force Update",
  EnterVersion: "Enter Version",

  // Page Content Configuration
  PageContentConfiguration: "Page Content Configuration",
  DetailsID: "Details ID",
  EnterDetailsID: "Enter Details ID",
  LanguageCode: "Language Code",
  LanguageID: "Language ID",
  EnterLanguageID: "Enter Language ID",
  DetailData: "Detail Data",
  EnterDetailData: "Enter Detail Data",

  // Virtual Card Product Type Configuration
  VirtualCardProductTypeConfiguration:
    "Virtual Card Product Type Configuration",
  ProductType: "Product Type",
  CardProductBIN: "Card Product BIN",
  EnterCardProductBIN: "Enter Card Product BIN",
  ProductID: "Product ID",
  EnterProductID: "Enter Product ID",
  ProductName: "Product Name",
  EnterProductName: "Enter Product Name",
  VerifiedBy: "Verified By",
  VerifiedDate: "Verified Date",
  VirtualCardProductTypeConfigurationConfirmation:
    "Virtual Card Product Type Configuration Confirmation",
  CardLimit: "Card Limit",
  EnterCardLimit: "Enter Card Limit",
  FinancialProfile: "Financial Profile",
  EnterFinancialProfile: "Enter Financial Profile",
  LimitCurrency: "Limit Currency",
  LimitGroup: "Limit Group",
  EnterLimitGroup: "Enter Limit Group",
  RMCode: "RM Code",
  EnterRMCode: "Enter RM Code",
  AllowInIntroductionPage: "Allow In Introduction Page",
  VirtualCardProductTypeDetails: "Virtual Card Product Type Details",
  SchemeCodeReq: "Scheme Code*",
  SchemecodeandConstitutionalreadyexistsatline:
    "Scheme code and Constitution already exists at line {0}",
  ConstitutionReq: "Constitution*",
  EnterConstitution: "Enter Constitution",

  //Customer Wise Limit Modification Confirmation
  CustomerWiseLimitModificationConfirmation:
    "Customer Wise Limit Modification Confirmation",
  CustomerName: "Customer Name",
  UserWiseLimitConfirmation: "User Wise Limit Confirmation",
  UserWiseLimitConfiguration: "User Wise Limit Configuration",
  Retry: "Retry",
  CustomerDetails: "Customer Details",
  CardMinimumAmt: "Card Minimum Amt.",
  MaximumAmountReq: "Maximum Amount*",
  MinimumAmountReq: "Minimum Amount*",
  DailyLimitReq: "Daily Limit*",
  Thistypealreadyexists: "This type already exists.",

  // Customer Activation
  CustomerActivation: "Customer Activation",
  ActivationUsing: "Activation Using",
  SelectOption: "Select Option",
  ClientID: "Client ID",
  EnterClientID: "Enter Client ID",
  CardNumber: "Card Number",
  DebitCardNumber: "Debit Card Number",
  CreditCardNumber: "Credit Card Number",
  EnterCardNumber: "Enter Card Number",
  EnterCreditCardNumber: "Enter Credit Card Number",
  EnterDebitCardNumber: "Enter Debit Card Number",
  RegWith: "Reg. With",
  RegAccount: "Reg. Account",
  Name: "Name",
  BirthDate: "Birth Date",
  EMailAddress: "E-Mail Address",
  NoteAfterconfirmationtemporarypasswordwillbesenttotheregisteredmobilenumber:
    "Note :- After confirmation temporary password will be sent to the registered mobile number.",
  FetchDetails: "Fetch Details",
  AccountCardNumber: "Account/Card Number",
  EnterAccountCardNumber: "Enter Account/Card Number",
  CustomerID: "Customer ID",
  EnterCustomerID: "Enter Customer ID",
  Constitution: "Constitution",
  AccountTypeName: "Account Type Name",
  Gender: "Gender",
  FatherName: "Father Name",
  MotherName: "Mother Name",
  LinkedAccount: "Linked Account",
  FullName: "Full Name",
  TINNumber: "TIN Number",
  NationalID13Digit: "National ID 13 Digit",
  ModeOfOperation: "Mode Of Operation",
  Nationality: "Nationality",
  NationalID: "National ID",
  IdentificationNumber: "Identification Number",
  CustomerCardDetails: "Customer Card Details",
  CardDetails: "Card Details",
  CustomerActivationConfirmation: "Customer Activation Confirmation",
  RequestDate: "Request Date",
  RequestNumber: "Request Number",
  RequestBy: "Request By",
  accountCardType: "Account Card/Type",

  // Customer Searching
  CustomerSearching: "Customer Searching",
  GetDetails: "Get Details",
  ClientIDCBNumber: "Client ID/CB Number",
  TIN: "TIN",
  NoteAllFieldscontainawildsearchfacility:
    "Note :- All Fields contain a wild search facility.",
  Pleaseenteravalidemailaddress: "Please enter a valid email address",
  PrimaryAccountCardNumber: "Primary Account/Card Number",
  PrimaryCBNumber: "Primary CB Number",
  PrimarySource: "Primary Source",
  AdminRemarks: "Admin Remarks",
  AuthFlag: "Auth. Flag",
  LimitModification: "Limit Modification",
  CurrentRelationshipData: "Current Relationship Data",
  Restrict: "Restrict",
  Unlock: "Unlock",
  Remarks: "Remarks",
  EnterRemarks: "Enter Remarks",
  TransactionTypeReq: "Transaction Type*",
  Dailylimitshouldbelessthanweeklylimit:
    "Daily limit should be less than weekly limit.",
  DailylimitshouldbelessthanMonthlylimit:
    "Daily limit should be less than Monthly limit.",
  WeeklyLimitshouldbemorethenDailyLimit:
    "Weekly Limit should be more then Daily Limit",
  PasswordReset: "Password Reset",
  CBNumber: "CB Number",
  IdentificationNo: "Identification No.",
  DoyouwanttoPasswordReset: "Do you want to Password Reset?",
  RefreshCustomerRelationshipData: "Refresh Customer Relationship Data",
  FetchData: "Fetch Data",
  PrimaryAccountCard: "Primary Account/Card",
  LastLoginDate: "Last Login Date",
  PasswordChangeDate: "Password Change Date",

  RestrictionRemarks: "Restriction Remarks",
  UnlockingRemarks: "Unlocking Remarks",
  UpdateData: "Update Data",

  // Password Reset Confirmation
  PasswordResetConfirmation: "Password Reset Confirmation",
  AcceptRemarks: "Accept Remarks",
  RejectionRemarks: "Rejection Remarks",

  // Primary Identifier Change
  PrimaryIdentifierChange: "Primary Identifier Change",
  Search: "Search",
  SignUpWith: "SignUp With",
  PrimaryIdentifierChangeConfirmation: "Primary Identifier Change Confirmation",
  OldPrimarySource: "Old Primary Source",
  NewPrimarySource: "New Primary Source",
  OldCBNumber: "Old CB Number",
  NewCBNumber: "New CB Number",
  OldCardAccountNumber: "Old Card/Account Number",
  NewCardAccountNumber: "New Card/Account Number",

  SetAsPrimary: "Set As Primary",
  DoyouwanttosetthisaccountcardasaPrimaryIdentifier:
    "Do you want to set this account/card as a Primary Identifier?",

  //CIB Loan Request Check
  CIBLoanRequestCheck: "CIB Loan Request Check",
  LoanRequestCheck: "Loan Request Check",
  FileNumber: "File Number",
  ApplicantName: "Applicant Name",
  TDAccount: "TD Account",
  LoanAmount: "Loan Amount",
  EMIAmount: "EMI Amount",
  LockBy: "Lock By",
  CIBCalculationView: "CIB Calculation | View",
  AppliedLoanamount: "Applied Loan amount",
  ProposedEMIamount: "Proposed EMI amount",
  AppliedTenor: "Applied Tenor",
  DOB: "DOB",
  DistrictofBirth: "District of Birth",
  NID: "NID",
  ETINNumber: "E-TIN Number",
  SmartCardNumber: "Smart Card Number",
  SpouseName: "Spouse Name",
  PermanentAddress: "Permanent Address",
  PresentAddress: "Present Address",
  CIBUserInformation: "CIB User Information",
  CIBStatus: "CIB Status",
  Pleaseselectstatus: "Please select status",
  DateRange: "Date Range",
  YouCantviewthisRequest: "You Can't view this Request.",
  FileUploadRequired: "File Upload Required.",
  DoYouwanttoacceptLoanRequest: "Do You want to accept Loan Request?",
  Decline: "Decline",

  // Loan Closure Request
  LoanClosureRequest: "Loan Closure Request",
  LoanAccount: "Loan Account",
  FromAccount: "From Account",
  ClosureDate: "Closure Date",
  Amount: "Amount",
  CreditAccount: "Credit Account",
  Outstanding: "Outstanding",
  ClosingFee: "Closing Fee",
  VAT: "VAT",
  TOTALAMOUNT: "TOTAL AMOUNT",

  //Tag Account Request
  TagAccountRequest: "Tag Account Request",
  RequestType: "Request Type",
  TagCreditCardRequest: "Tag Credit Card Request",
  SearchingParameters: "Searching Parameters",
  AppliedFilters: "Applied Filters",

  // Loan Release Lock Request
  LoanReleaseLockRequest: "Loan Release Lock Request",
  FDAccount: "FD Account",
  RequestReleasedSuccessfully: "Request Released Successfully.",
  AreYouSuretoReleaseLockedRequest: "Are You Sure to Release Locked Request?",

  // From Source Key Template
  FromSourceKeyTemplate: "From Source Key Template",
  SettoFromSource: "Set to From Source",
  ResponseValue: "Response Value*",
  EnterResponseValue: "Enter Response Value",
  TemplateSetAs: "Template Set As",
  CurrentConfig: "Current Config.",
  SetFromSourceKeyTemplateOf: "Set From Source Key Template Of",

  // Account Deletion Request For Checker
  AccountDeletionRequestForChecker: "Account Deletion Request For Checker",
  PrimaryAccount: "Primary Account",
  PrimaryCBNo: "Primary CB No.",
  DeletionReason: "Deletion Reason",
  RejectRemarks: "Reject Remarks",

  // Account Deletion Request For Approval
  AccountDeletionRequestForApproval: "Account Deletion Request For Approval",
  AcceptedBy: "Accepted By",
  CheckerAcceptDate: "Checker Accept Date",
  CheckerRemarks: "Checker Remarks",

  // Rooted Device Repository Allow/Disallow
  RootedDeviceRepositoryAllowDisallow:
    "Rooted Device Repository Allow/Disallow",
  RootedDeviceRepository: "Rooted Device Repository",
  DeviceID: "Device ID",
  DevicesOS: "Device OS",
  DeviceName: "Device Name",
  DeviceUserName: "Device User Name",
  DeviceIP: "Device IP",
  AppVersion: "App Version",
  DeviceIMEI: "Device IMEI",
  Maker: "Maker",
  MakerRemark: "Maker Remark",
  Checker: "Checker",
  CheckerRemark: "Checker Remark",
  Disallow: "Disallow",
  Allow: "Allow",
  AllowRemarks: "Allow Remarks",
  DisallowRemarks: "Disallow Remarks",
  RootedDeviceAllowDisallowConfirmation:
    "Rooted Device Allow/Disallow Confirmation",
  ConfirmationRemarks: "Confirmation Remarks",

  // Corporate User Registration Entry
  CorporateUserRegistrationEntry: "Corporate User Registration Entry",
  DomainName: "Domain Name",
  RegDate: "Reg. Date",
  ACNo: "A/C. No.",
  Sign: "Sign",
  OwnAC: "Own A/C",
  SanctionAmount: "Sanction Amount",
  WithinBank: "Within Bank",
  EFT: "EFT",
  IMPS: "IMPS",
  UtilityBillPayment: "Utility Bill Payment",
  PaymentGetway: "Payment Getway",
  FromAmounts: "From Amount",
  ToAmounts: "To Amount",
  ByNumberofUser: "By Number of User",
  CustomerType: "Customer Type",
  PersonName: "Person_Name",
  Document: "Document",
  DocumentNo: "Document No",
  UploadDocument: "Upload Document",
  ViewDocument: "View Document",
  AuthLetter: "Auth. Letter",
  ViewAuthLetter: "View Auth. Letter",
  Deactive: "Deactive",
  DeactiveReason: "Deactive Reason",
  UserRights: "User Rights",
  PanNo: "PAN No.",
  UserLimit: "User Limit",
  ViewOnly: "View Only",
  PerDayLimit: "Per Day Limit",
  SpecialAuthorized: "Special Authorized",
  CorporateUserRegistration: "Corporate User Registration",
  PerDayMaxLimit: "Per Day Max Limit",
  Limit: "Limit",
  ControllingPerson: "Controlling Person",
  CorporateFinanceDepartment: "Corporate Finance Department",
  AccountMapping: "Account Mapping",
  AuthenticationWorkflow: "Authentication Workflow",
  EffectiveDailyLimit: "Effective Daily Limit",
  LimitAmount: "Limit Amount",

  // Admin Panel User Maintenance
  AdminPanelUserMaintenance: "Admin Panel User Maintenance",
  UserGroupName: "User Group Name",
  GroupName: "Group Name",
  AllowRelease: "Allow Release",
  UserSubtype: "User Sub Type",
  NotificationTemplate: "Notification Template",
  ConfirmedStatus: "Confirmed Status",
  AdminPanelUserConfirmation: "Admin Panel User Confirmation",
  UserLevel: "User Level",
  EnterUserID: "Enter User ID",
  EnterUserfullnamehere: "Enter User full name here",
  ConfirmPasswordValidation:
    "New Password and Confirm Password did not matched",
  ChangePasswordValidation:
    "Password should be alphanumeric and have at least one special character, one lowercase character, one uppercase character without any space in between.",
  NewPassword: "New Password",
  ConfirmPassword: "Confirm Password",
  InactiveDate: "Inactive Date",
  UpdateDetails: "Update Details",
  AdminUserConfirmation: "Admin User Confirmation",
  ConfirmationColumnDetails: "Confirmation Column Details",
  OldValue: "Old Value",
  LabelName: "Label Name",
  NewValue: "New Value",
  MakerDate: "Maker Date",
  MobileNoisrequired: "Mobile Number is required",

  // Admin Panel User Release
  AdminPanelUserRelease: "Admin Panel User Release",
  LoginTime: "Login Time",
  Operation: "Operation",
  LoginDateTime: "Login Date-Time",
  BlockedReason: "Blocked Reason",
  LogoutDateTime: "Logout Date-Time",
  ViewAll: "View All",
  ReleaseBlockedUser: "Release Blocked User",
  ReleaseUsers: "Release User(s)",
  Userissuccessfullyreleased: "User is successfully released",
  Loggedin: "Logged in",
  WouldyouliketoreleasetheselectedBlockedUsers:
    "Would you like to release the selected Blocked User(s)?",
  WouldyouliketoreleasetheselectedLoggedinUsers:
    "Would you like to release the selected Logged in User(s)?",
  ReleaseBlockedUsers: "Release Blocked User(s)",
  AdminPanelBlockedUserRelease: "Admin Panel Blocked User Release",
  BlockedUserName: "Blocked User Name",
  FailureAttemptCount: "Failure Attempt Count",
  ListofFailedLoginAttempts: "List of Failed Login Attempts",
  UserFailedAttemptDetails: "User Failed Attempt Details",
  ReleaseReason: "Release Reason",
  ApplicationSessionID: "Application Session ID",

  // Screen Access Rights
  ScreenAccessRights: "Screen Access Rights",
  GroupNames: "Group Names",
  AccessDetail: "Access Detail",
  Groups: "Groups",
  Users: "Users",
  Youcannotmodifyyourownrights: "You can not modify your own rights.",
  AreyouwanttopopulateitsGroupRight:
    "Are you want to populate it's Group Right?",
  MenuList: "Menu List",
  PendingScreenAccess: "Pending Screen Access",
  CurrentScreenAccess: "Current Screen Access",
  AssignUserGroupRights: "Assign User/Group Rights",
  CarryForwardScreenRightsFrom: "Carry Forward Screen Rights From",
  YoucannotCarryForwardRightsforsameuser:
    "You can not Carry Forward Rights for same user.",
  AssignUserGroupRightsTo: "Assign User/Group Rights To ",
  FastForward: "Fast Forward",
  FastRewind: "Fast Rewind",
  ScreenAccessRightsOf: "Screen Access Rights Of {0} User",
  User: " User",

  // Admin Panel User Group
  AdminPanelUserGroupCreation: "Admin Panel User Group Creation",
  NoofScreenstodisplayunderRecentOption:
    "No. of Screens to display under Recent Option",
  LoginPasswordForceExpiryDays: "Login Password Force Expiry Days",
  EnterLoginPasswordForceExpiryDays: "Enter Login Password Force Expiry Days",
  AdminUserGroupMaintenance: "Admin User Group Maintenance",
  EnterUserGroupName: "Enter User Group Name",
  NoofScreensunderRecentOption: "No. of Screens under Recent Option",
  EnterNoofScreensunderRecentOption: "Enter No. of Screens under Recent Option",
  UserGroup: "User Group",

  // Admin User Notification Template
  AdminUserNotificationTemplate: "Admin User Notification Template",
  NotificationTemplateName: "Notification Template Name",
  AdminUserNotificationTemplateName: "Admin User Notification Template Name",
  EnterAdminUserNotificationTemplateName:
    "Enter Admin User Notification Template Name",
  UserLoginIDReq: "User Login ID*",
  USERLoginIDisAlreadyenteredatLine: "USER Login ID is Already entered at Line",

  // Release Block Users
  ReleaseBlockUsers: "Release Block Users",
  ReleaseTypeReq: "Release Type*",
  BlockTypeReq: "Block Type*",
  BlockDate: "Block Date",
  BlockReason: "Block Reason",
  ReleaseCardPINBlockUsers: "Release Card PIN Block Users",
  ActivityType: "Activity Type",
  Details: "Details",
  Areyousureyouwanttorelease: "Are you sure you want to release",
  ReleasePGWBlockUsers: "Release PGW Block Users",
  Fetch: "Fetch",

  // DBR Loan Request Check
  DBRLoanRequestCheck: "DBR Loan Request Check",
  CustomerLoanRequestInformation: "Customer Loan Request Information",
  Profession: "Profession",
  NetMonthlyIncomeA: "Net Monthly Income (A)",
  TDAccountNumber: "TD Account Number",
  TenorMonth: "Tenor(Month)",
  TDAmountC: "TD Amount (C)",
  RateofInterest: "Rate of Interest",
  EMIB: "EMI (B)",
  AccountforEncashEMI: "Account for Encash EMI",
  DBRBA: "DBR(B/A)%",
  LoanRequestRecommendedInformation: "Loan Request Recommended Information",
  LoanAmountD: "Loan Amount (D)",
  OtherLoanInstF: "Other Loan Inst. (F)",
  CreditCardlimitG: "Credit Card limit (G)",
  DBRF5ofGA100: "DBR% ((F + 5% of G)/A)*100",
  EMIE: "EMI (E)",
  LTVDC: "LTV% (D/C)",
  FinalLoanAmountLTVC: "Final Loan Amount (LTV * C)",
  CIBRemarks: "CIB Remarks",
  MessagefromDBR: "Message from DBR",
  DBRRemarks: "DBR Remarks",
  Requesthasalreadybeenprocessed: "Request has already been processed.",
  ViewDocuments: "View Documents",

  // Loan Approval Detail
  LoanApprovalDetail: "Loan Approval Detail",
  LoanApprovalRequestDetails: "Loan Approval Request Details",
  FileReferenceNo: "File Reference No.",
  SecurityValueTDAmount: "Security Value/TD Amount",
  AssessedbyDBRID: "Assessed by/DBR ID",
  AssessedbyDBRName: "Assessed by/DBR Name",
  AssessedDate: "Assessed Date",
  LTV: "LTV%",
  NetMonthlyIncome: "Net Monthly Income",
  Tenor: "Tenor",
  OtherLoanInstallment: "Other Loan Installment",
  CreditCardlimit: "Credit Card limit",
  EMI: "EMI",
  DBR: "DBR",
  SOLID: "SOL ID",
  FinalLoanAmount: "Final Loan Amount",
  MessageFromApproval: "Message From Approval",

  // Enter Retrieval Parameters
  EnterRetrievalParameters: "Enter Retrieval Parameters",
  ToDateshouldbegreaterthanorequaltoFromDate:
    "To Date should be greater than or equal to From Date.",
  FromDateshouldbelessthanorequaltoToDate:
    "From Date should be less than or equal to To Date.",
  today: "today",
  accept: "accept",
  cancel: "cancel",

  //REPORT
  RetrievalParameters: "Retrieval Parameters",
  Searched: "Search",
  records: "records",
  showFilters: "show Filters",
  ClearFilter: "Clear Filter",
  ExpandRows: "Expand Rows",
  Export: "Export",
  Showexportoptions: "Show export options",
  RetrieveData: "Retrieve Data",
  RequiredValueMissingForLoginID: "Required Value Missing For LoginID",
  rowswillbeexported: "row(s) will be exported.",
  Nodatafoundtoexport: "No data found to export",
  ReportExportStatus: "Report Export Status",
  // Customer Registration Report
  CustomerRegistrationReport: "Customer Registration Report",
  RegAccountCardNumber: "Reg. Account/Card Number",
  Source: "Source",
  AuthWith: "Auth. With",
  LastPassChange: "Last Pass. Change",

  // User Login History
  UserLoginHistory: "User Login History",
  LoginDate: "Login Date",
  LoginBy: "Login By",

  // Password Change History
  PasswordChangeHistory: "Password Change History",
  PasswordModifyDate: "Password Modify Date",

  // User Activity
  UserActivity: "User Activity",
  ActivityCode: "Activity Code",
  ActivityTime: "Activity Time",
  ActivityDescription: "Activity Description",

  // Fund Transfer Transaction Details
  FundTransferTransactionDetails: "Fund Transfer Transaction Details",
  TransactionStatus: "Transaction Status",
  TransactionDate: "Transaction Date",
  VATAmount: "VAT Amount",
  FromSource: "From Source",
  FromACNo: "From A/C No.",
  FromACName: "From A/C Name.",
  ToACNo: "To A/C No.",
  ToACName: "To A/C Name.",
  ToIFSCCode: "To IFSC Code",
  ProcessDate: "Process Date",
  RefNo: "Ref No.",
  OTPType: "OTP Type",
  FromContactNo: "From Contact No.",
  FromEmailID: "From Email ID",
  ToContactNo: "To Contact No.",
  ToEmailID: "To Email ID",
  TransFlow: "Trans. Flow",
  NickName: "Nick Name",

  APIResponseDetailsReport: "API Response Details Report",
  ApiName: "API Name",
  RespCode: "Resp. Code",
  RefTranID: "Ref.Tran.ID",
  ResponseMessage: "Response Message",
  ResponseDate: "Response Date",
  ExportReportform: "Export Report Form",

  Selectfiletype: "Select file type",
  Selectpagesize: "Select page size",
  Selectorientation: "Select orientation",
  ShowHeader: "Show Header",
  ColumnstoExport: "Columns to Export",
  TransactionParticularsDetail: "Transaction Particulars Detail",
  Print: "Print",
  ResponseDetail: "Response Detail",

  TransactionRefNumber: "Transaction Ref. Number",
  FromAccountNumber: "From Account Number",
  AbabilTrnParticulars: "Ababil Trn. Particulars",
  AbabilTrnParticulars2: "Ababil Trn. Particulars2",
  TranzwareTrnParticulars: "Tranzware Trn. Particulars",
  TranzwareTrnParticulars2: "Tranzware Trn. Particulars2",

  // Service Active/Deactive Register
  ServiceActiveDeactiveRegister: "Service Active/Deactive Register",
  SubTranType: "Sub Tran. Type",
  FromDates: "From Date",
  ToDates: "To Date",
  DisplayMessage: "Display Message",
  DisplayMessageDetail: "Display Message Detail",

  // Mobile/Email Updation From Core Report
  MobileEmailUpdationFromCoreReport: "Mobile/Email Updation From Core Report",
  UpdatedField: "Updated Field",

  // OTP Notification Report
  OTPNotificationReport: "OTP Notification Report",
  TRNCode: "TRN Code",
  MobileNoEmailID: "Mobile No./Email ID",
  SentTime: "Sent Time",
  MessageDescription: "Message Description",
  ApiResp: "Api Resp",
  PageNumber: "Page Number",
  EnterPageNumber: "Enter Page Number",
  PageSize: "Page Size",
  EnterPageSize: "Enter Page Size",

  // List Of Club Member Report
  ListOfClubMemberReport: "List Of Club Member Report",
  Pleaseselectatleastonerow: "Please select at least one row.",

  // Mobile/Email Notification Report
  MobileEmailNotificationReport: "Mobile/Email Notification Report",
  MessageType: "Message Type",

  // Beneficiary Detail Report
  BeneficiaryDetailReport: "Beneficiary Detail Report",
  BeneficiaryType: "Beneficiary Type",

  // Mobile/Email Updation From Citytouch Report
  MobileEmailUpdationFromCitytouchReport:
    "Mobile/Email Updation From Citytouch Report",
  ResponseCode: "Response Code",

  // Email Transfer Transaction Details
  EmailTransferTransactionDetails: "Email Transfer Transaction Details",
  AcceptStatus: "Accept Status",
  ResentCount: "Resent Count",
  CancelReason: "Cancel Reason",

  // Cash By Code Transaction Details
  CashByCodeTransactionDetails: "Cash By Code Transaction Details",
  FromCardNumber: "From Card Number",
  LinkedACNo: "Linked A/C No.",
  CodeViewBy: "Code View By",
  CashByCode: "Cash By Code",
  BenConatctNo: "Ben. Conatct No.",

  // Favourite Transaction Details
  FavouriteTransactionDetails: "Favourite Transaction Details",
  FavType: "Fav. Type",
  FavTranname: "Fav. Tran. name",

  // Payment Details
  PaymentDetails: "Payment Details",
  PaymentDate: "Payment Date",
  ToSource: "To Source",
  ServiceCharge: "Service Charge",
  Mobile: "Mobile",
  ResponseDesc: "Response Desc.",
  RefTransactionID: "Ref.Transaction ID",
  MerchantName: "Merchant Name",
  Frequency: "Frequency",
  AsonDate: "As on Date",
  DeselectAll: "Deselect All",
  SelectAll: "Select All",

  // Schedule Payment Details
  SchedulePaymentDetails: "Schedule Payment Details",
  LastProcessDate: "Last Process Date",
  DeactiveChannel: "Deactive Channel",
  PaymentType: "Payment Type",
  NoofPayments: "No. of Payments",
  PolicyNumber: "Policy Number",
  PolicyHolderName: "Policy Holder Name",
  PolicyPaidType: "Policy Paid Type",
  ScheduleResponse: "Schedule Response",

  ScheduleDetailsReport: "Schedule Details Report",
  ScheduleDate: "Schedule Date",
  FromAccountNo: "From Account No.",
  FromAccountName: "From Account Name",
  ToAccountNo: "To Account No",
  ToAccountName: "To Account Name",
  BenContactNo: "Ben. Contact No.",
  BenEmailID: "Ben. Email ID.",
  RefDate: "Ref. Date",

  // Card Activate/Reset Pin Report
  CardActivateResetPinReport: "Card Activate/Reset Pin Report",
  TypeOfTran: "Type Of Tran.",
  CardNo: "Card No.",
  OldStatusOfCard: "Old Status Of Card",
  NewStatusOfCard: "New Status Of Card",
  ChangeReason: "Change Reason",
  ResponseMesssage: "Response Messsage",

  // Tag Credit Card And Account Number Details
  TagCreditCardAndAccountNumberDetails:
    "Tag Credit Card And Account Number Details",
  AcOrCardNo: "A/c. Or Card No.",
  AcceptBy: "Accept By",
  AcceptDate: "Accept Date",
  AcceptanceRemarks: "Acceptance Remarks",

  // Untag Credit Card And Account Number Details
  UntagCreditCardAndAccountNumberDetails:
    "Untag Credit Card And Account Number Details",

  // Positive Pay Request Report
  PositivePayRequestReport: "Positive Pay Request Report",
  BeneficiaryName: "Beneficiary Name",
  ChequeDate: "Cheque Date",
  ChequeNumber: "Cheque Number",
  ChequeBookNumber: "Cheque Book Number",

  // QR Generated Report
  QRGeneratedReport: "QR Generated Report",
  QRID: "QR ID",
  Currency: "Currency",
  ProcessStatus: "Process Status",

  // QR Merchant Payment Report
  QRMerchantPaymentReport: "QR Merchant Payment Report",

  // Cheque Book Request Report
  ChequeBookRequestReport: "Cheque Book Request Report",
  NoOfLeaf: "No. Of Leaf",
  DeliveryBranch: "Delivery Branch",

  // Cheque Stop Request Report
  ChequeStopRequestReport: "Cheque Stop Request Report",
  BeginChequeNo: "Begin Cheque No.",
  ChequeNo: "Cheque No.",
  ContactNo: "Contact No.",
  EnterContactNo: "Enter Contact No.",

  // User Block Unblock Report
  UserBlockUnblockReport: "User Block Unblock Report",
  BlockType: "Block Type",

  // Apply for Fixed Deposite Request Report
  ApplyforFixedDepositeRequestReport: "Apply for Fixed Deposite Request Report",
  TypeOfAccount: "Type Of Account",
  AccountTitle: "Account Title",
  AvilBalance: "Avil Balance",
  TenureType: "Tenure Type",
  AutoRenewal: "Auto Renewal",
  IntRepayAccount: "Int./Repay Account",
  CollectionBranch: "Collection Branch",
  InterestRate: "Interest Rate",
  MaturityDate: "Maturity Date",
  ApplyForDepositPensionSchemeReport: "Apply For Deposit Pension Scheme Report",
  InstallStartDate: "Install Start Date",
  GeneratedAccount: "Generated Account",

  // Credit Card Payment Report
  CreditCardPaymentReport: "Credit Card Payment Report",
  ReferenceNo: "Reference No",
  FromACNumber: "From A/C Number",
  ToCardNo: "To Card No.",
  Recipientname: "Recipient Name",
  RecipientEmail: "Recipient Email",
  CurrCode: "Curr Code",
  ToCurrCode: "To Curr Code",
  CurrInt: "Curr Int.",
  CardType: "Card Type",
  TotalAmount: "Total Amount",

  // Admin Panel User Application Usage History
  AdminPanelUserApplicationUsageHistory:
    "Admin Panel User Application Usage History",
  OpenDateAndTime: "Open Date And Time",
  CloseDateAndTime: "Close Date And Time",

  // Apply for Quick Loan Summary Report
  ApplyforQuickLoanSummaryReport: "Apply for Quick Loan Summary Report",
  RequestDateandTime: "Request Date and Time",
  EMIAccount: "EMI Account",
  IntRate: "Int.Rate",

  ApplyforQuickLoanDetailReport: "Apply for Quick Loan Detail Report",
  LoanTenure: "Loan Tenure",
  MonthlyIncome: "Monthly Income",
  ProcessingFee: "Processing Fee",
  FileREFNo: "File REF No.",
  ETINNo: "E TIN No.",
  NIDNo: "NID No.",
  SmartCardNo: "Smart Card No.",
  BirthPlace: "Birth Place",
  SoalID: "Soal ID",
  SanIntRate: "San.Int.Rate",
  OtherLoanEMI: "Other Loan EMI",
  SanLoanAmount: "San Loan Amount",
  EMIDate: "EMI Date",
  CCLimitAmount: "CC.Limit Amount",
  SanInstAmount: "San Inst.Amount",
  DBRAmount: "DBR Amount",
  CIBUser: "CIB User",
  CIBEnteredDate: "CIB Entered Date",
  CIBMachineName: "CIB Machine Name",
  DBRUsers: "DBR Users",
  DBREnteredDate: "DBR Entered Date",
  DBRMachineName: "DBR Machine Name",
  AuthUser: "Auth User",
  AuthRemarks: "Auth Remarks",
  AuthEnteredDate: "Auth Entered Date",
  AuthMachineName: "Auth Machine Name",
  RejectedBy: "Rejected By",
  RejectedDate: "Rejected Date",
  RejectedMachineName: "Rejected Machine Name",
  FDBalance: "FD Balance",

  // Merchant Transaction Report
  MerchantTransactionReport: "Merchant Transaction Report",
  RequestDateTime: "Request Date Time",
  UniqueID: "Unique ID",
  BankRefID: "Bank Ref ID",
  MerchantReferenceID: "Merchant Reference ID",
  TokenNo: "Token No",
  ServiceType: "Service Type",
  ReverseStatus: "Reverse Status",

  // Supporting Documents Upload Report
  SupportingDocumentsUploadReport: "Supporting Documents Upload Report",
  RegistrationDate: "Registration Date",
  ChangeRequestType: "Change Request Type",
  APIResponceID: "API Responce ID",
  DocumentName: "Document Name",
  DocumentFileName: "Document File Name",

  // Pay Order Details Report
  PayOrderDetailsReport: "Pay Order Details Report",
  TransactionTime: "Transaction Time",
  TypeOfFundTransfer: "Type Of FundTransfer",
  DeliveryBranchName: "Delivery Branch Name",
  TransferRefNumber: "Transfer Ref Number",

  // FDR Issuance Report
  FDRIssuanceReport: "FDR Issuance Report",
  RequestCompletedDateTime: "Request Completed Date Time",
  SOLDescription: "SOL Description",
  CIFID: "CIF ID",
  FDRType: "FDR Type",
  AcName: "A/c. Name",
  AcOpeningDate: "A/c.Opening Date",
  IntCreditAcID: "Int. Credit A/c. ID",
  IntCreditAcName: "Int. Credit A/c. Name",
  ValueDate: "Value Date",
  DepositAmount: "Deposit Amount",
  DepositPeriod: "Deposit Period",
  TenorType: "Tenor Type",
  MaturityValue: "Maturity Value",
  RepaymentAcID: "Repayment A/c ID",
  RepaymentAcName: "Repayment A/c Name",
  MaturityInstructions: "Maturity Instructions",
  AutoClosure: "Auto Closure",
  SectorCode: "Sector Code",
  SubSectorCode: "Sub Sector Code",
  OccupationCode: "Occupation Code",
  FreeCode3: "Free Code 3",
  FreeCode6: "Free Code 6",
  FreeCode7: "Free Code 7",
  DebitAcID: "Debit A/c. ID",
  DebitAcName: "Debit A/c. Name",
  NomineesName: "Nominee's Name",
  Relationship: "Relationship",
  AddressLine1: "Address Line1",
  AddressLine2: "Address Line2",
  NomineePhotoID: "Nominee Photo ID",
  City: "City",
  State: "State",
  Country: "Country",
  NomineeMinor: "Nominee Minor",
  DateOfBirth: "Date Of Birth",
  NomineePent: "Nominee Pent.",
  RequestID: "Request ID",

  // DPS Issuance Report
  DPSIssuanceReport: "DPS Issuance Report",
  SISrlNo: "SI Srl.No.",
  StandInstFreqType: "Stand. Inst. Freq. Type",
  DayofStandInstFreq: "Day of Stand. Inst. Freq.",
  StandInstFreq: "Stand. Inst. Freq.",
  NextExecutionDate: "Next Execution Date",

  // API Response Report
  APIResponseReport: "API Response Report",
  APICallCount: "API Call Count",

  // Admin Panel User Information Report
  AdminPanelUserInformationReport: "Admin Panel User Information Report",
  CreationDate: "Creation Date",

  // Admin Panel User Activity Report
  AdminPanelUserActivityReport: "Admin Panel User Activity Report",
  LogDescription: "Log Description",
  LoginIpAddress: "Login Ip Address",
  Terminal: "Terminal",
  ReleasedBy: "Released By",
  ReleasedDate: "Released Date",
  ReleasedIpAddress: "Released Ip Address",

  // Perameters Audit Trail
  PerametersAuditTrail: "Parameters Audit Trail",
  PeraNo: "Pera No.",
  ModifiedDateTime: "Modified Date - Time",

  // Admin Panel User Audit Trail Detail
  AdminPanelUserAuditTrailDetail: "Admin Panel User Audit Trail Detail",
  ActionDateTime: "Action Date & Time",
  AdminPanelUserWiseScreenAccessReport:
    "Admin Panel User Wise Screen Access Report",
  ScreenCode: "Screen Code",

  // Monthly Service And Channel Wise MAU Report
  MonthlyServiceAndChannelWiseMAUReport:
    "Monthly Service And Channel Wise MAU Report",
  Month: "Month",
  Transaction: "Transaction",
  Volume: "Volume",
  UniqueCustomer: "Unique Customer",
  DailyServiceAndChannelWiseMAUReport:
    "Daily Service And Channel Wise MAU Report",
  PleaseSelectAtLeastOneChannel: "Please select at least one Channel.",
  PleaseSelectAtLeastOneTrnType: "Please select at least one Transaction Type.",

  // Monthly User And Channel Wise MAU Report
  MonthlyUserAndChannelWiseMAUReport:
    "Monthly User And Channel Wise MAU Report",
  NumberOfService: "Number Of Service",
  DailyUserAndChannelWiseMAUReport: "Daily User And Channel Wise MAU Report",

  // Primary Identifier Change Report
  PrimaryIdentifierChangeReport: "Primary Identifier Change Report",
  OldSource: "Old Source",
  NewSource: "New Source",
  OldCardaccountNo: "Old Card/account No.",
  NewCardaccountNo: "New Card/account No.",
  ChangedBy: "Changed By",
  ChangedDate: "Changed Date",

  // Device Change Report
  DeviceChangeReport: "Device Change Report",

  // Currently Login Customer Details Report
  CurrentlyLoginCustomerDetailsReport:
    "Currently Login Customer Details Report",
  LastLoginDateTime: "Last Login DateTime",
  LastActivityDateTime: "Last Activity DateTime",
  InactiveTime: "Inactive Time",
  TTL: "TTL",
  LastActivityType: "Last Activity Type",
  LastActivityDescription: "Last Activity Description",

  // Mobile Recharge Details Report
  MobileRechargeDetailsReport: "Mobile Recharge Details Report",
  ConnectionType: "Connection Type",
  OTPMobileNumber: "OTP Mobile Number",
  OTPEmailID: "OTP Email ID",

  // Account Deletion Request Report
  AccountDeletionRequestReport: "Account Deletion Request Report",
  PrimaryCBCID: "Primary CB/CID",
  CheckerDate: "Checker Date",

  // Topup Reversal Report
  TopupReversalReport: "Topup Reversal Report",
  TopupTranCode: "Topup Tran Code",
  MerechantRefID: "Merechant Ref. ID",
  AmountStatus: "Amount Status",
  RequestIP: "Request IP",
  Rechargedate: "Recharge date",

  // Merchant Transaction Reversal Report
  MerchantTransactionReversalReport: "Merchant Transaction Reversal Report",
  ReversedBy: "Reversed By",
  ReversedDateTime: "Reversed Date Time",
  AcceptedDateTime: "Accepted Date Time",
  ReversedMachineName: "Reversed Machine Name",
  AcceptedMachineName: "Accepted Machine Name",

  // User Status Change Audit Report
  UserStatusChangeAuditReport: "User Status Change Audit Report",
  NewStatus: "New Status",

  //Utility Bill Payment Report
  UtilityBillPaymentReport: "Utility Bill Payment Report",
  Category: "Category",
  TrnStatus: "Trn Status",
  Retrieve: "Retrieve",
  BillNumber: "Bill Number",
  GrandTotal: "Grand Total",
  OTPMobileNo: "OTP Mobile No.",
  TransactionRefID: "Transaction Ref. ID",
  OtherDetails: "Other Details",

  // Daily Service And Channel Wise Charges report
  DailyServiceAndChannelWiseChargesreport:
    "Daily Service And Channel Wise Charges report",
  MonthlyServiceAndChannelWiseChargesReport:
    "Monthly Service And Channel Wise Charges Report",

  // Insurance Premium Payment Report
  InsurancePremiumPaymentReport: "Insurance Premium Payment Report",
  CompanyName: "Company Name",
  TransferType: "Transfer Type",
  ToAccount: "To Account",

  // MFS Transfer Transation Details
  MFSTransferTransationDetails: "MFS Transfer Transaction Details",
  TransationDate: "Transation Date",
  TransationType: "Transation Type",

  // Customer Wise Global Limit Usage Report
  CustomerWiseGlobalLimitUsageReport: "Customer Wise Global Limit Usage Report",
  GlobalLimit: "Global Limit",
  TransactionCount: "Transaction Count",
  MFSvolume: "MFS volume",
  WithinBankVolume: "Within Bank Volume",
  OtherBankVolume: "Other Bank Volume",
  PaymentVolume: "Payment Volume",

  // IDTP Registration Report
  IDTPRegistrationReport: "IDTP Registration Report",
  VID: "VID",
  DefualtDebitAccount: "Defualt Debit Account",
  DefualtCreditAccount: "Defualt Credit Account",
  DefualtRTPAccount: "Defualt RTP Account",
  RegistrationType: "Registration Type",

  // IDTP Transfer Report
  IDTPTransferReport: "IDTP Transfer Report",
  SenderVID: "Sender VID",
  ReceiverVID: "Receiver VID",
  ReceiverName: "Receiver Name",
  InterOperableFee: "InterOperable Fee",
  PlatformFee: "Platform Fee",
  RTPID: "RTP ID",
  SwiftCode: "Swift Code",
  SDKResponseCode: "SDK Response Code",
  ReqestID: "Reqest ID",
  ReferanceNumber: "Referance Number",
  RefNoSendingPSP: "Ref.No. Sending PSP",
  RefNoReceivingPSP: "Ref.No. Receiving PSP",
  RefNoReceivingBank: "Ref.No.Receiving Bank",
  RefNoIDTP: "Ref.No. IDTP",

  // IDTP Create RTP Report
  IDTPCreateRTPReport: "IDTP Create RTP Report",
  UserVID: "User VID",

  // IDTP Beneficiary Detail Report
  IDTPBeneficiaryDetailReport: "IDTP Beneficiary Detail Report",
  BeneficiaryVID: "Beneficiary VID",

  // IDTP Transaction PIN Change Report
  IDTTransactionPINChangeReport: "IDTP Transaction PIN Change Report",

  // Password Reset Through Admin Panel Report
  PasswordResetThroughAdminPanelReport:
    "Password Reset Through Admin Panel Report",
  MakerMachine: "Maker Machine",
  CheckerMachine: "Checker Machine",

  // IDTP Forgot PIN Report
  IDTPForgotPINReport: "IDTP Forgot PIN Report",
  VirtualID: "Virtual ID",
  AcOrCardNumber: "A/c. Or Card Number",

  // IDTP RTP Decline Report
  IDTPRTPDeclineReport: "IDTP RTP Decline Report",
  SenderName: "Sender Name",
  SenderVirtualID: "Sender Virtual ID",

  // Virtual Card Request Report
  VirtualCardRequestReport: "Virtual Card Request Report",
  CardProductName: "Card Product Name",
  NameOnCard: "Name On Card",
  CurrencyCode: "Currency Code",
  PassportNumber: "Passport Number",
  CorrespondenceAddress: "Correspondence Address",

  // Dynamic Report Configure
  DynamicReportConfigure: "Dynamic Report Configure",
  SQLANSIQuerySyntax: "SQL ANSI Query Syntax",
  PleaseEnterSQLSyntax: "Please Enter SQL Syntax.",
  PleaseVerifySQLSyntax: "Please Verify SQL Syntax.",
  Parameters: "Parameters",
  Title: "Title",
  EnterTitle: "Enter Title",
  RetrievalType: "Retrieval Type",
  DisableGroupBy: "Disable Group By",
  HideAmountIn: "Hide Amount In",
  HideFooter: "Hide Footer",
  ColumnAccessor: "Column Accessor",
  EnterColumnAccessor: "Enter Column Accessor",
  ColumnName: "Column Name",
  EnterColumnName: "Enter Column Name",
  ColumnWidth: "Column Width",
  EnterColumnWidth: "Enter Column Width",
  ColumnType: "Column Type",
  EnterColumnType: "Enter Column Type",
  ColumnFilterType: "Column Filter Type",
  IsVisible: "Is Visible",
  CreatedBy: "Created By",
  CreatedDate: "Created Date",
  QuerySuccessfullyVerified: "Query Successfully Verified.",
  ColumnFormat: "Column Format",
  EnterColumnFormat: "Enter Column Format",
  WhereSequence: "Where Sequence",
  EnterWhereSequence: "Enter Where Sequence",
  AccessRights: "Access Rights",
  DynamicReportAccessRights: "Dynamic Report Access Rights",
  Userrightsupdatedsuccessfully: "User rights updated successfully.",
  Verify: "Verify",
  Done: "Done",

  UserList: "User List",
  Club: "Club",

  startswith: "starts with",
  endswith: "ends with",
  equal: "equal",
  contains: "contains",

  PleaseSelectValidStartTime: "Please Select Valid Start Time",
  PleaseSelectValidEndTime: "Please Select Valid End Time",
  MonthlyLimitshouldgreaterthanorequaltoDailyLimit:
    "Monthly Limit should greater than or equal to Daily Limit",
  MonthlyLimitshouldgreaterthanorequaltoWeeklyLimit:
    "Monthly Limit should greater than or equal to Weekly Limit",
  MaximumAmountshouldgreaterthanorequaltoMinimumAmount:
    "Maximum Amount should greater than or equal to Minimum Amount",
  WeeklyLimitshouldgreaterthanorequaltoDailyLimit:
    "Weekly Limit should greater than or equal to Daily Limit",

  viewmode: "view mode",
  newmode: "new mode",
  editmode: "edit mode",
  confirmmode: "confirm mode",
  addmode: "add mode",

  SelectCompute: "Select Compute",

  BusinessDayhasbeennotgeneratedPleasegenerateaBusinessDaythroughtheViewDetailsScreen:
    "Business Day has been not generated. Please generate a Business Day through the View Details Screen.",
  SelectBranchName: "Select Branch Name",
  StartdatemustbegreaterthanpreviousEnddate:
    "Start date must be greater than previous End date",
  SelectParentType: "Select Parent Type",
  SelectLeavesTemplate: "Select Leaves Template",
  SelectCharges: "Select Charges",
  SelectOperatorType: "Select Operator Type",
  SelectOptionType: "Select Option Type",
  SelectChargeTemplate: "Select Charge Template",
  SelectAccountSource: "Select Account Source",
  DragandDropor: "Drag and Drop or",
  Browse: "Browse",
  DropFileshere: "Drop Files here",
  SelectSourceName: "Select Source Name",
  SelectSourceType: "Select Source Type",
  SelectDistrict: "Select District",
  SelectTransactionType: "Select Transaction Type",
  SelectAccountType: "Select Account Type",
  SelectTenureType: "Select Tenure Type",
  SelectRestrictionType: "Select Restriction Type",
  SelectUsecase: "Select Use case",
  SelectChannel: "Select Channel",
  SelectDisplayType: "Select Display Type",
  SelectBannerType: "Select Banner Type",
  SelectTenureTypeFinacle: "Select Tenure Type Finacle",
  SelectRenewal: "Select Renewal",
  SelectDataType: "Select Data Type",
  SelectMFSService: "Select MFS Service",
  SelectDescription: "Select Description",
  SelectAllowDisallow: "Select Allow/Disallow",
  SelectTemplate: "Select Template",
  SelectCardStatus: "Select Card Status",
  SelectOperationType: "Select Operation Type",
  SelectEnableStatus: "Select Enable Status",
  SelectDeviceOS: "Select Device O.S.",
  SelectServiceName: "Select Service Name",
  SelectTemplateName: "Select Template Name",
  SelectProductType: "Select Product Type",
  SelectLimitCurrency: "Select Limit Currency",
  SelectLanguageID: "Select Language ID",
  SelectMerchantID: "Select Merchant ID",
  SelectTerminalID: "Select Terminal ID",
  SelectCharge: "Select Charge",
  SelectGatewayNamePID: "Select Gateway Name (PID)",
  SelectUserRole: "Select User Role",
  SelectUserStatus: "Select User Status",
  SelectActionMenu: "Select Action Menu",
  SelectResponseKey: "Select Response Key",
  SelectUserLevel: "Select User Level",
  SelectGroupName: "Select Group Name",
  SelectUserSubType: "Select User Sub Type",
  SelectNotificationTemplate: "Select Notification Template",
  SelectUserLoginID: "Select User Login ID",
  ErrorDetails: "Error Details",
  ShowLess: "Show Less",
  ShowMore: "Show More",
  Atleastonerowmustbeindetail: "Atleast one row must be in detail.",
  All: "All",
  UploadProfilePhoto: "Upload Profile Photo",
  Filenotfound: "File not found",
  Profilepictureupdatedsuccessfully: "Profile picture updated successfully.",
  Zoom: "Zoom",
  Rotate: "Rotate",
  UpdatePhoto: "Update Photo",
  ServiceChargeDetails: "Service Charge Details",
  Addedsuccessfully: "Added successfully",
  Updatedsuccessfully: "Updated successfully",
  EditChargeTemplate: "Edit Charge Template",
  AreyousureyouwanttodeletetheselectedRecord:
    "Are you sure you want to delete the selected Record?",
  Disagree: "Disagree",
  Agree: "Agree",
  EditChecklistDetails: "Edit Checklist Details",
  EnterFromAmount: "Enter From Amount",
  EnterToAmount: "Enter To Amount",
  EnterChargeAmount: "Enter Charge Amount",
  EnterChargePercent: "Enter Charge Percent",
  AddChargeTemplateDetail: "Add Charge Template Detail",
  AccessDenied: "Access Denied!",
  Usernameisnotvalid: "Username is not valid",
  OopsPageNotFound: "Oops! Page Not Found",
  Pleaseselectatleastonecolumn: "Please select atleast one column!",
  Nodatafoundtoexports: "No data found to export!",
  ResendOTP: "Resend OTP",

  OTPVerification: "OTP Verification",
  PleaseEnterOTP: "Please Enter OTP",
  ForgotTOTP: "Forgot TOTP",

  SelectCategory: "Select Category",
  SelectBillerName: "Select Biller Name",
  SelectTrnStatus: "Select Trn Status",
  SelectStatus: "Select Status",
  SelectOTPType: "Select OTP Type",
  SelectMerchantName: "Select Merchant Name",
  SelectTransactionStatus: "Select Transaction Status",
  SelectFrequency: "Select Frequency",
  SelectAccessChannel: "Select Access Channel",
  AreyousureyouwanttodeletetheselectedRecords:
    "Are you sure you want to delete the selected Records",
  AllRecordssuccessfullydeleted: "All Records successfully deleted",
  LoginPasswordForceExpiryDaysmustbeavalidnumberbetween1to30:
    "Login Password Force Expiry Days must be a valid number between 1 to 30.",

  IDTPAliasUpdateReport: "IDTP Alias Update Report",
  ExistingAlias: "Existing Alias",
  NewAlias: "View Alias",
  SelectLanguage: "Select Language",
  AreyouSureyouwanttodeletethisrecord:
    "Are you Sure you want to delete this record?",
  Recordsuccessfullydeleted: "Record successfully deleted",
  Pleasewaitdeletingrecord: "Please wait deleting record",
  NoRecordsFoundclicktheaddbuttontoaddone:
    "No Records Found, click the add button to add one",
  Maximize: "Maximize",
  EnterDefaultValue: "Enter Default value",
  IsTotalWithoutCurrency: "Is Total Without Currency",
  IsTotalWithCurrency: "Is Total With Currency",
  IsVisibleCurrencySymbol: "Is Visible Currency Symbol",
  IsCurrencyCode: "Is Currency Code",
  CurrencyReferenceColumn: "Currency Reference Column",

  //Password Rotation
  PasswordRotation: "Password Rotation",
  CurrentPassword: "Current Password",
  EnterCurrentPassword: "Enter Current Password",
  EnterNewPassword: "Enter New Password",
  ConfirmNewPassword: "Confirm New Password",
  Enterconfirmnewpassword: "Enter confirm new password",
  CurrentPasswordisrequired: "Current Password is required.",
  Thenewpasswordcannotbethesameastheoldpassword:
    "The new password cannot be the same as the old password",
  Confirmnewpasswordisrequired: "Confirm new password is required.",
  NewPasswordandConfirmPassworddidnotmatched:
    "New Password and Confirm Password did not matched",
  Passwordsuccessfullychanged: "Password successfully changed.",
  //
  CardProductBin: "Card Product Bin",
  ModeofOperation: "Mode of Operation",
  AccountStatus: "Account Status",

  //Push Notification Master
  PushNotificationMaster: "Push Notification Master",
  UserType: "User Type",
  SelectUserType: "Select User Type",
  ExecuteDate: "Execute Date",
  EnterExecuteDate: "Enter Execute Date",
  SelectLoginID: "Select Login ID",
  EnterCustomerName: "Enter Customer Name",
  EnterLastLoginDate: "Enter Last Login Date",
  PushNotificationMasterConfirmation: "Push Notification Master Confirmation",

  // Push Notification Template Configuration
  PushNotificationTemplateConfiguration:
    "Push Notification Template Configuration",
  Subject: "Subject",
  EnterSubject: "Enter Subject",
  EnterTemplateName: "Enter Template Name",
  PushNotificationTemplateConfigurationPreview:
    "Push Notification Template Configuration Preview",
  EnterDeviceID: "Enter Device ID",
  Preview: "Preview",
  Test: "Test",
  PushNotificationTemplateConfirmation:
    "Push Notification Template Confirmation",
  FromAmountshouldbelessToAmount: "From Amount should be less To Amount",

  Mobilenumbermustbe11digitslong:
    "Mobile number should be greater than 9 digit.",
  UserRestrictProcessing: "User Restrict Processing",
  PrimaryStatus: "Primary Status",
  CardID: "Card ID",
  EnterCardID: "Enter Card ID",
  TapPayDetails: "Tap & Pay Details",
  TapPay: "Tap & Pay",

  //IBMB Product

  LanguageReq: "Language*",
  MessageReq: "Message*",
  EnterMessage: "Enter Message",
  MessageNoteReq: "Message Note*",
  MessageNote: "Message Note",
  EnterMessageNote: "Enter Message Note",
  EnterMessageCode: "Enter Message Code",
  LanguageisAlreadyenteredatLine: "Language is Already entered at Line {0}",
  SelectCurrencyCode: "Select Currency Code",
  DefaultNote: "Default Note",
  EnterDefaultNote: "Enter Default Note",

  CommonMessageTemplate: "Common Message Template",
  Message: "Message",
  SelectMessage: "Select Message",

  // password Policy Configuration
  PasswordPolicyConfiguration: "Password Policy Configuration",
  PasswordType: "Password Type",
  MinimumLength: "Minimum Length",
  MaximumLength: "Maximum Length",
  UpperCaseRequire: "UpperCase Require",
  LowerCaseRequire: "LowerCase Require",
  SpecialCharacterRequire: "Special Character Require",
  DigitsRequire: "Digits Require",
  NoSpaces: "No Spaces",
  EnterPasswordType: "Enter Password Type",
  EnterMinimumLength: "Enter Minimum Length",
  EnterMaximumLength: "Enter Maximum Length",
  NoofPreviousPasswordNotAllowed: "No of Previous Password Not Allowed",
  EnterNoofPreviousPasswordNotAllowed:
    "Enter No of Previous Password Not Allowed",
  MinimumUpperCase: "Minimum UpperCase",
  EnterMinimumUpperCase: "Enter Minimum UpperCase",
  MinimumLowerCase: "Minimum LowerCase",
  EnterMinimumLowerCase: "Enter Minimum LowerCase",
  MinimumDigits: "Minimum Digits",
  EnterMinimumDigits: "Enter Minimum Digits",
  MinimumSpecialCharater: "Minimum Special Charater",
  EnterMinimumSpecialCharater: "Enter Minimum Special Charater",
  AllowedSpecialCharacter: "Allowed Special Character",
  EnterAllowedSpecialCharacter: "Enter Allowed Special Character",
  MinimumEnglishCharacter: "Minimum English Character",
  EnterMinimumEnglishCharacter: "Enter Minimum English Character",
  ExpireDays: "Expire Days",
  EnterExpireDays: "Enter Expire Days",
  AlertBeforeExpireDays: "Alert Before Expire Days",
  EnterAlertBeforeExpireDays: "Enter Alert Before Expire Days",
  Pleaseenteronlyspecialcharacters: "Please enter only special characters",

  EnterAccountSource: "Enter Account Source",
  EnterAccountType: "Enter Account Type",
  EditAllowed: "Edit Allowed",
  EnteraproperVersion: "Enter a proper Version",
  InternetBanking: "Internet Banking",
  MobileBanking: "Mobile Banking",
  MaskedAccountCardNo: "Masked Account Card No",

  AccountCustomerID: "Account Customer ID",
  EnterAccountCustomerID: "Enter Account Customer ID",
  AccountCardNo: "Account/Card No.",
  MakerRemarks: "Maker Remarks",
  PrimaryCustomerID: "Primary Customer ID",

  SecurityQuestionMasterConfiguration: "Security Question Master Configuration",
  SecurityQuestion: "Security Question",
  SecurityQuestionGroupCD: "Security Question Group",
  EnterSecurityQuestions: "Enter Security Questions",
  SecurityQuestionConfigurationConfirmation:
    "Security Question Configuration Confirmation",
  SecurityQuestionConfiguration: "Security Question Configuration",
  SelectDefaultMessage: "Select Default Message",
  Unknownerroroccured: "Unknown error occured",

  OtherBankMaster: "Bank Master",
  OtherBranchMaster: "Other Bank Branch Master",
  OtherRegionMaster: "Region Master",

  // State Township MAster Configuration Screen

  StateTownshipMasterConfiguration: "State Township Master Configuration",
  StateCode: "State Code",
  EnterStateCode: "Enter State Code",
  StateName: "State Name",
  EnterStateName: "Enter State Name",
  TownshipCode: "Township Code",
  EnterTownshipCode: "Enter Township Code",
  TownshipName: "Township Name",
  EnterTownshipName: "Enter Township Name",
  // Suspense Account Template Configuration

  SuspenseAccountTemplateConfiguration: "Suspense Account Template",
  SuspenseAccountTemplateConfirmation: "Suspense Account Template Confirmation",
  TransactionRemark1: "Transaction Remark 1",
  EnterTransactionRemark1: "Enter Transaction Remark 1",
  TransactionRemark2: "Transaction Remark 2",
  EnterTransactionRemark2: "Enter Transaction Remark 2",
  AccountTypeReq: "Account Type*",
  AccountTypeisAlreadyenteredatLine:
    "Account Type is Already entered at Line {0}",
  // Currency Limit Template Configuration

  CurrencyLimitTemplateConfiguration: "Currency Limit Template Configuration",
  CurrencyLimitTemplateConfirmation: "Currency Limit Template Confirmation",
  DailyAmount: "Daily Amount*",
  WeeklyAmount: "Weekly Amount",
  MonthlyAmount: "Monthly Amount",
  MaximumDailyCount: "Maximum Daily Count",
  MaximumWeeklyCount: "Maximum Weekly Count",
  MaximumMonthlyCount: "Maximum Monthly Count",
  CurrencyCodeReq: "Currency Code*",
  EnterOrderBy: "Enter Order By",

  CurrencyReq: "Currency*",
  SelectCurrency: "Select Currency",
  EitherChargeAmountOrChargePercentageIsRequired:
    "Either Charge Amount or Charge Percentage is required",

  //Account Wise ChargeAccountSpecificChargeTemplate Template setting
  AccountSpecificChargeTemplate: "Account-Specific Charge Template",
  ServiceChargeTemplateReq: "Service Charge Template",
  AccountClassificationReq: "Account Classification*",
  AcParameterMappingTemplateReq: "A/c. Parameter Mapping Template*",
  AccountSpecificChargeTemplateConfirmation:
    "Account-Specific Charge Template Confirmation",
  AccountSourceNumber: "Account/Source Number",
  ThisCurrencyAlreadyExists: "This Currency Already Exists",
  AccountParametersMappingTemplate: "Account Parameters Mapping Template",
  FromSourceKeyValueConfigMapping:
    "From Source Key Value Configuration Mapping",
  AcParameterMappingTemplate: "A/c. Parameter Mapping Template",
  ConfigurationType: "Configuration Type",
  PresetAmountConfiguration: "Preset Amount Configuration",
  TemplateCode: "Template Code",

  LimitTemplateReq: "Limit Template*",
  LimitTemplate: "Limit Template",
  SelectLimitTemplate: "Select Limit Template",
  AccountTemplate: "Account Charge Template",
  SelectAccountTemplate: "Select Account Charge Template",
  GloballimitTemplate: "Global limit Template",
  SelectGloballimitTemplate: "Select Global limit Template",

  ProfileTemplate: "Profile Template",
  ProfileTemplateConfirmation: "Profile Template Confirmation",

  // service master

  ServiceMaster: "Service Master",
  ServiceMasterConfirmation: "Service Master Confirmation",
  SuspenseAccountDetails: "Suspense Account Details",
  ChargeAllow: "Charge Allow",
  SuspenseAccountTemplate: "Suspense Account Template",
  SelectSuspenseAccountTemplate: "Select Suspense Account Template",
  AccountSourceReq: "Account Source*",

  // Wallet Master
  WalletMaster: "Wallet Master",
  WalletMasterConfirmation: "Wallet Master Confirmation",
  WalletType: "Wallet Type",
  EnterWalletType: "Enter Wallet Type",
  WalletName: "Wallet Name",
  EnterWalletName: "Enter Wallet Name",
  WalletIDValidateRegex: "Wallet ID Validate RegExp",
  EnterWalletIDValidateRegex: "Enter Wallet ID Validate RegExp",
  WalletIDRegExpNotaValid: "Wallet ID RegExp Not a Valid ",

  Areyousureyouwanttoupdatetheprofiletemplateforthisuser:
    "Are you sure you want to update the profile template for this user?",
  Theholidaydatemustbebetweenthestartdateandenddate:
    "The holiday date must be between the start date and end date.",
  SelectCardType: "Select Card Type",
  CardStatusisAlreadyenteredatLine:
    "Card Status is Already entered at Line {0}",
  CardCategory: "Card Category",
  CardApplyConfirmation: "Card Application Confirmation",
  ProofType: "Proof Type",
  ProofValue: "Proof Value",
  CardApplyDetails: "Card Application Details",
  ClicktoViewFullImage: "Click to View Full Image",
  DoubleClicktoCloseImage: "Double Click to Close Image",
  RequestDetail: "Request Detail",

  AppAnnualExpense: "Applicant's Annual Expense",
  AppAnnualIncome: "Applicant's Annual Income",
  AppCompanyName: "Applicant's Company Name",
  AppPosition: "Applicant's Position",

  CredentialsResetRequestHistoryReport:
    "Credentials Reset Request History Report",
  AuthenticationFlow: "Authentication Flow",
  BankRegion: "Bank Region",
  MobileAccountLinkReport: "Mobile Account Link Report",
  ActionFlag: "Action Flag",
  TRFType: "TRF Type",
  WalletTopUpDetails: "Wallet Top Up Details",
  ToWalletId: "To Wallet ID",
  ToWalletNM: "To Wallet Name",
  OtherBankFundTransferDetails: "Other Bank Fund Transfer Details",
  NRCFundTransferDetails: "NRC Fund Transfer Details",
  CreditCardPaymentDetails: "Credit Card Payment Details",
  RecipientMobileNo: "Recipient Mobile Number",
  FormAccountNo: "From A/C No.",
  CardResetPinReport: "Card Reset Pin Report",
  PinChangeReason: "Pin Change Reason",
  CardApplicationDetails: "Card Application Details",
  PartyDetails: "Party Details",
  BlockUnblockCardPinDetails: "Block/Unblock Card Pin Details",
  CardActivationDetails: "Card Activation Details",
  MobileNoLengthGreter6Digit:
    "Mobile no. length must be greater than 6 digits.",

  InActiveDate: "In Active Date",
  TransactionAllowed: "Transaction Allowed",
  selectTransactionAllowed: "Select Transaction Allowed",
  Mobilenumbermustbe9digitslong: "Mobile Number must be 9 digits long",
  Mobilenumbermustbe7digitslong:
    "Mobile number must be at least 7 digits long.",
  SearchServiceName: "Search Service Name",
  AppliedLimits: "Applied Limits",

  CardProductMaster: "Card Product Master",
  CardProductMasterConfirmation: "Card Product Master Confirmation",

  StatementType: "Statement Type",
  SentStatus: "Sent Status",
  AccountStatementReport: "Account Statement Report",
  ChargeAmount: "Charge Amount",
  ToSourceFlag: "To Source Flag",
  ServiceUnavailableAction: "Service Unavailable Action",
  SelectServiceUnavailableAction: "Select Service Unavailable Action",
  ServiceUnavailableActionReq: "Service Unavailable Action*",
  AllowAccess: "Allow Access",
  ProfileReq: "Profile*",
  SelectProfile: "Select Profile",
  ThisChannelalreadyexists: "This Channel already exists",
  ThisProfilealreadyexists: "This Profile already exists",
  BranchMasterConfirmation: "Branch Master Confirmation",
  FromSourceKeyValueConfigurationConfirmation:
    "From Source Key Value Confirmation",
  FromSourceKeyValueConfirmation: "From Source Key Value Confirmation",

  IntraFundTransferDetails: "Intra Fund Transfer Transaction Details",
  ErrorCode: "Error Code",
  ToAccountCardNo: "To Account/Card Number",
  CardApplicationPartiesDetails: "Card Application Parties Details",
  FromAccountBalance: "From Account Balance",
  RetryCount: "Retry Count",
  CallResponse: "Call Response",
  ReferenceID: "Reference ID",
  RefereneceDate: "Reference Date",
  BatchID: "Batch ID",
  APIStatus: "API status",
  APIExecutionTime: "API Execution Time",
  ChannelLimit: "Channel Limit",
  ChannelLimitConfiguration: "Channel Limit Configuration",
  ChannelLimitConfirmation: "Channel Limit Confirmation",
  TransactionAllowedReq: "Transaction Allowed*",

  BranchServiceStatusTitle: "Branch Service Status Updation",
  BranchServiceStatusCountNote: "Selected Branch: ",
  BranchServiceStatusNote:
    "Note: Please choose the service and status for updating across all the selected Branch.",
  BranchServiceStatusUpdateMsg:
    "Are you sure you want to {0} the {1} service in all the selected branch?",

  SelectCommonMessageTemplate: "Select Common Message Template",
  Specialcharactersandspacesarenotallowed:
    "Special characters and spaces are not allowed",

  ResetFlag: "Reset Flag",
  DeviceUsername: "Device Username",
  AccountCardType: "Account/Card Type",
  LastScheduledDate: "Last Scheduled Date",
};
